import { element } from 'protractor';
import {
  Component,
  OnInit,
  ElementRef,
  ViewChildren,
  ViewChild,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Inject,
  ViewRef,
  HostListener,
  Optional
}
  from '@angular/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader, MatOptionSelectionChange } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// RXJS
import { ReplaySubject, BehaviorSubject, Subject } from 'rxjs';
//Service
import { DeNghiNhapKhoService } from '../kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
//Model
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { DeNghiNhapKhoChiTiet, DeNghiNhapKho } from '../kho-de-nghi-nhap-kho-page-model/kho-de-nghi-nhap-kho-page.model';
import { Router, ActivatedRoute } from '@angular/router';
import { DNNKLSNhapKhoDialogComponent } from '../kho-lich-su-nhap-list-dialog/kho-lich-su-nhap-list-dialog.component';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { COMMA, ENTER, L } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material';
import { NhapQuyTrinhDuyetService } from '../../../quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service';

@Component({
  selector: 'm-kho-de-nghi-nhap-kho-add-edit-page',
  templateUrl: './kho-de-nghi-nhap-kho-add-edit-page.component.html',
  styleUrls: ['../kho-de-nghi-nhap-kho-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe]
})

export class DeNghiNhapKhoAddEditComponent implements OnInit {

  @ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
  @ViewChild('fileUploadImport', { static: false }) fileUploadImport: ElementRef;
  @ViewChildren("otherReason") otherReason;
  @ViewChildren("coChungTu") coChungTu;
  @ViewChildren('focusDetail') focusDetail;

  /*----------------------------Config Form ---------------------------*/
  CONFIG: CommonConFig;
  /* ------------------------------------------------------------------*/

  /*--------------------Comment columns mat-table----------------------*/
  displayedColumns = [];
  availableColumns = [
    {
      stt: 1,
      name: '#',
      displayName: '#',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 2,
      name: 'MaHH',
      displayName: 'Mã hàng',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 3,
      name: 'TenHH',
      displayName: 'Tên hàng',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 4,
      name: 'QuyCach',
      displayName: 'Quy cách',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 5,
      name: 'Solo',
      displayName: 'Số lô',
      alwaysChecked: false,
      isShow: true
    },

    {
      stt: 6,
      name: 'Soluongchungtu',
      displayName: 'SL',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 7,
      name: 'TenDVT',
      displayName: 'ĐVT',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 8,
      name: 'SoLuongThucNhap',
      displayName: 'SL thực nhập',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 9,
      name: 'SoMay',
      displayName: 'Số máy',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 10,
      name: 'SoXeSoMe',
      displayName: 'Số mẻ/số xe',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 11,
      name: 'MaThung',
      displayName: 'MaThung',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 12,
      name: 'PalletText',
      displayName: 'PalletText',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 12,
      name: 'XacThucPallet',
      displayName: 'Xác thực pallet',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 14,
      name: 'NgayDongThung',
      displayName: 'Ngày đóng thùng',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 14,
      name: 'NgaySanXat',
      displayName: 'Ngày sản xuất',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 13,
      name: 'LenhSX',
      displayName: 'Lệnh SX',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 15,
      name: 'ExpiryDate',
      displayName: 'Hạn sử dụng',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 15,
      name: 'NgayNhanHang',
      displayName: 'Ngày nhận hàng',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 16,
      name: 'Tag',
      displayName: 'Tags',
      alwaysChecked: false,
      isShow: true
    },

    {
      stt: 17,
      name: 'SoPOKH',
      displayName: 'Số PO KH',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 17,
      name: 'SoPONCC',
      displayName: 'Số PO NCC',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 18,
      name: 'NCC',
      displayName: 'NCC',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 18,
      name: 'OBJTHCP',
      displayName: 'Đối tượng THCP',
      alwaysChecked: false,
    },
    {
      stt: 19,
      name: 'Ghichulohang',
      displayName: 'Ghi chú',
      alwaysChecked: false,
      isShow: true
    },
    {
      stt: 99,
      name: 'actions',
      displayName: 'Thao tác',
      alwaysChecked: true,
      isShow: true
    }
  ];
  sumColums: string[] = ['#', 'Soluongchungtu', 'SoLuongThucNhap'];

  /* ------------------------------------------------------------------*/
  // TREE
  public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
  optionsDivision: any[] = [];
  usingDivisionFtrCtrl: string = '';

  ID_Struct: string = '';
  show_rooms = new BehaviorSubject<boolean>(false);
  orgStructureTree: any[] = [];
  sltReceiveDivison: string = "";
  ftrReceiveDivison: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  receiveDivisonFtrCtrl: string = '';
  sltRequestDepartment: string = "";
  ftrRequestDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  requestDepartmentFtrCtrl: string = '';
  ftrImportDepartment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  importDepartmentFtrCtrl: string = '';
  /*--------------------Mat select search cho hàng hóa-----------------*/
  listId_HH: any[] = [];
  selectId_HH: string = '';
  filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  Id_HHFilterCtrl: string = '';
  haveElementId_HH: boolean = false;
  sumRecord = 0;
  /* ------------------------------------------------------------------*/

  /* ------------------------------- Danh sách khách hàng ----------------------------------- */
  listId_KH: any[] = [];
  selectedId_KH: number = 0;
  filteredId_KH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  sumRecord_KH = 0;
  arrayKHForEachHH: any[] = [];
  KHFilterCtrl: string = '';
  /*------------------------ Danh sách trạng thái ----------------------*/
  listState: any[] = [];
  nameState: string = '';
  /* ------------------------------------------------------------------ */


  /*------------------------ Danh sách phòng ban -----------------------*/
  listPB: any[] = [];
  PBUser: string = '';
  selectPB: string = '';
  filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  PBFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------------ Danh sách bộ phận ----------------------*/
  listBP: any[] = [];
  selectBP: string = '';
  filteredBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  BPFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*--------------------- Danh sách Khu vực sản xuất -------------------*/
  listKVSX: any[] = [];
  selectKVSX: string = '';
  filteredKVSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  KVSXFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------------ Danh sách loại phiếu ----------------------*/
  listLoaiPhieu: any[] = [];
  selectLoaiPhieu: string = '';
  filteredLoaiPhieu: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  LoaiPhieuFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------------ Danh sách lý do ----------------------*/
  listLyDo: any[] = [];
  selectlistLyDo: string = '';
  filteredlistLyDo: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  listLyDoFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------ Danh sách giai đoạn hàng hóa---------------------*/
  listGDHH: any[] = [];
  selectGDHH: string = '';
  filteredGDHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  GDHHFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------------ Danh sách ĐVT -----------------------------*/
  listDVT: any[] = [];
  selectListDVT: string = '';
  filteredListDVT: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  ListDVTFilterCtrl: string = '';
  /* ------------------------------------------------------------------ */

  /*------------------------ Danh sách NCC -----------------------------*/
  listNCC: any[] = [];
  selectNCC: string = '';
  filteredNCC: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  NCCFilterCtrl: string = '';
  arrayNCCForEachHH: any[] = [];
  /* ------------------------------------------------------------------ */
  /*------------------------ Đối tượng THCP -----------------------------*/
  listObjTHCP: any[] = [];
  selectObjTHCP: string = "";
  filteredObjTHCP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  objTHCPFilterCtrl: string = "";
  haveElementObjTHCP: boolean = false;
  searchObjTHCP: Subject<string> = new Subject<string>();
  loadingObjTHCP = new BehaviorSubject<boolean>(false);
  requireDivisionInUse = new BehaviorSubject<boolean>(false);
  requireDepartmentInUse = new BehaviorSubject<boolean>(false);

  /* ------------------------------Selection ---------------------------*/
  selectedColumns = new SelectionModel<any>(true, this.availableColumns);
  selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);
  /* ------------------------------------------------------------------ */


  /* --------------------------- Loading.... ---------------------------*/
  loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();
  /* ------------------------------------------------------------------ */


  /* ------------------- Các form trên dialog --------------------------*/
  DNNKForm: FormGroup;				     //Form thông tin đề nghị nhập kho
  HHForm: FormGroup;			            //Form add hàng hóa cho phiếu
  ImportHHForm: FormGroup;			    //Form import hàng hóa cho phiếu
  /* ------------------------------------------------------------------ */


  /*---------------------- Thông tin thao tác cho phiếu --------------- */
  DNNKItem: DeNghiNhapKho;
  listChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
  tmpChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
  beforeTmpChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
  /* ------------------------------------------------------------------ */


  /*------------------------- Extend field: ----------------------------*/
  title: string = '';					// Tiêu đề dialog
  previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
  fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
  saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
  saveAddedCT: number[] = []
  viewLoading: boolean = false;   	// Loading khi mở dialog
  disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
  processImport: boolean = false;		// Có đang chạy import
  flagTab: number = 0;				// Định danh tab đang chạy
  openTimKiemNangCao = false;
  isCopy: boolean = false;
  waittingLoadingXX: boolean = false;
  keywordChanged: Subject<string> = new Subject<string>();
  loadingMerchandise = new BehaviorSubject<boolean>(false);
  fakeOptionNumber: number = 5;
  minDate = new Date();
  isFromPurchaseOrder: boolean = false;
  /* ------------------------------------------------------------------ */

  /*------------------------- Support tags: ----------------------------*/
  @ViewChild('tagInput', { static: false }) tagInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  filteredTags: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedTag: string[] = [];
  listTag: string[] = [];
  listTagFull: any[] = [];
  rowUpdate: number = -1;
  isPageForm = new BehaviorSubject<boolean>(true);
  /* ------------------------------------------------------------------ */

  /*------------------------- Loading btn import: ----------------------------*/
  loadingImportFile = new BehaviorSubject<boolean>(false);
  loadingDownloadTemplate = new BehaviorSubject<boolean>(false);
  /* ------------------------------------------------------------------ */

  constructor(
    @Optional() public dialogRef: MatDialogRef<DeNghiNhapKhoAddEditComponent>,
    private deNghiNhapKhoService: DeNghiNhapKhoService,
    private dungChungService: DungChungService,
    private DNNKFB: FormBuilder,
    private HHFB: FormBuilder,
    private ImportFB: FormBuilder,
    public dialog: MatDialog,
    private router: Router,
    private tokenStorage: TokenStorage,
    private changeDetect: ChangeDetectorRef,
    private layoutUtilsService: LayoutUtilsService,
    private subheaderService: SubheaderService,
    private activatedRoute: ActivatedRoute,
    private treeService: NhapQuyTrinhDuyetService,

    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    // ------ Hàm làm mới danh sách hàng hóa mỗi khi search
    if (this.keywordChanged) {
      this.keywordChanged
        .pipe(
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe(value => {
          this.ListId_HH(value);
        });
    }
    this.searchObjTHCP.pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(res => { this.ListObjTHCP(res); });
    this.minDate.setHours(0, 0, 0, 0);
  }

  /*---------------------------- LOAD DATA --------------------------------*/
  ngOnInit() {
    /*Load all dropdown and create form */
    this.getTree();
    this.ListPB();
    this.loadListKhachHang();
    this.ListTagKho();
    this.ListId_HH();
    this.ListState();
    this.ListLoaiPhieu();
    this.ListObjTHCP();
    this.ListLyDo();
    //this.ListBoPhan();
    this.ListGDHH();
    this.ListDVT();
    this.ListNCC();

    /*Load cấu hình config form */
    this.CONFIG = new CommonConFig();
    // this.listTag = CommonConFig.TagKho;
    this.DNNKItem = new DeNghiNhapKho();
    this.DNNKItem.clear();
    this.createForm();

    // .. Xử lý dialog
    if (this.data && this.data.data) {
      if (this.data && this.data.type === 'DoiTraHang') {
        this.handleDoiTraHangFormDialog();
      } else if (this.data && this.data.source === "FROM_PURCHASE_ORDER") {
        this.isFromPurchaseOrder = true;
        this.handleFormFromPurchaseOrder(this.data.data);
      } else {
        this.handleFormDialog();
      }
    }
    // .................................................
    // .. Xử lý page
    if (!this.data) {
      var data = window.history.state
      if (data != null && data.isCopy) {
        this.isCopy = data.isCopy;
      }
      this.activatedRoute.params.subscribe(params => {
        const id = +params.id;

        if ((id && id > 0) || this.isCopy) {
          this.DNNKItem.IdDn = id;
          if (this.isCopy) {
            this.DNNKItem.IdDn = data.Id;
          }
          this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
            if (res.status == 1) {
              this.DNNKItem = res.data
              this.DNNKItem.isCreateQT = true;
              if (res.data.Tinhtrang != DeNghiNhapKho.optionsTinhTrang[0].value && !this.isCopy) {
                this.router.navigateByUrl('/404');
              }
              if (this.DNNKForm != null) {
                this.bindingValueAfterCallAPIDetail();
              }
            }
          });
        } else {
          this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
          this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
            if (res.status == 1) {
              this.DNNKItem.Sophieu = res.data;
              if (localStorage.getItem("DataDNNKSource") && this.DNNKItem.IdDn == 0) {
                this.DNNKItem = JSON.parse(localStorage.getItem("DataDNNKSource"));
                this.DNNKItem.isCreateQT = false;
                this.bindingValueAfterGetDataLenhSanXuat();
              }
              if (localStorage.getItem("DataDNNKThuaSource") && this.DNNKItem.IdDn == 0) {
                this.DNNKItem = JSON.parse(localStorage.getItem("DataDNNKThuaSource"));
                this.DNNKItem.isCreateQT = false;
                this.bindingValueAfterGetDataLenhSanXuat();
              }
              if (this.DNNKForm != null)
                this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
            }
          });
        }
      });
    }
    // .................................................
    this.title = this.getTitle();

    /* Filter list Hang hoa when value change*/
    this.HHForm.get('MaHang').valueChanges.subscribe(newValue => {
      this.filterId_HH(newValue);
    });
    this.DNNKForm.get('MaKhachHang').valueChanges.subscribe(newValue => {
      this.filterId_KH('' + newValue);
    });
    this.HHForm.get('PalletText').valueChanges.subscribe(newValue => {
      if (newValue == null && !this.isFromPurchaseOrder) {
        this.HHForm.controls["PalletText"].setValue('PL');
      }
      if (newValue != undefined) {
        if (!newValue.toString().includes("PL")) {
          this.HHForm.controls["PalletText"].setValue('PL');

        }

      }
      this.isDisableButton();
      this.changeDetectView();
    })
    this.HHForm.get('Solo').valueChanges.subscribe(newValue => {
      if (newValue == null) {
        var currentDateString = new Date().toLocaleDateString('en-GB').split('/').join('').slice(-2) + new Date().toLocaleDateString('en-GB').split('/').join('').slice(0, 4);
        var year = currentDateString.slice(0, 2);
        var day = currentDateString.slice(2, 4);
        var month = currentDateString.slice(4);
        var formattedDateString = day + month + year;
        this.HHForm.controls["Solo"].setValue(formattedDateString);
      }

    })
    this.HHForm.get('TagInfo').valueChanges.subscribe(newValue => {
      if (newValue) {
        let newList = this.listTag.filter(tag => tag.toLowerCase().indexOf(newValue.toLowerCase()) > -1)
        this.filteredTags.next(newList);
      } else {
        this.filteredTags.next(this.listTag.slice())
      }
    });

    let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị nhập kho', page: '/de-nghi-nhap-kho' }, { title: ((this.DNNKItem.IdDn > 0 && !this.isCopy) ? 'Cập nhật' : 'Thêm mới') + ' đề nghị nhập kho' }];
    this.subheaderService.setBreadcrumbs(breadcrumbs);

    /*Show column */
    this.showColumnsInTable();
    this.applySelectedColumns();
  }
  ngOnDestroy() {
    this.clearDataImport();
  }

  remove(fruit: string): void {
    const index = this.selectedTag.indexOf(fruit);
    if (index >= 0) {
      this.selectedTag.splice(index, 1);
    }
  }
  removeEl(fruit: string, index: number): void {
    let el = this.tmpChiTietDNNK[index];
    if (el) {
      let idx = el.TagInfo.indexOf(fruit);
      if (idx >= 0) {
        el.TagInfo.splice(idx, 1);
      }
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.selectedTag.includes(event.option.viewValue))
      this.selectedTag.push(event.option.viewValue);
    this.tagInput.nativeElement.value = '';
    this.HHForm.controls['TagInfo'].setValue(null);
    this.changeDetectView();
  }
  selectedEl(event: MatAutocompleteSelectedEvent, index: number): void {
    let el = this.tmpChiTietDNNK[index];
    if (el && !el.TagInfo.includes(event.option.viewValue))
      el.TagInfo.push(event.option.viewValue);
    this.changeDetectView();
  }
  filterSearch(event: any) {
    if (!event) return null;
    let value = event.target.value;
    if (value) {
      let newList = this.listTag.filter(tag => tag.toLowerCase().indexOf(value.toLowerCase()) > -1)
      this.filteredTags.next(newList);
    } else {
      this.filteredTags.next(this.listTag.slice());
    }
    this.changeDetectView();
  }
  /* -----------------------------------------------------------------------*/
  // disablePLText(event: KeyboardEvent) {
  // 	const inputValue = this.HHForm.get('PalletText').value;
  // 	if (event.key === 'Backspace' && inputValue === 'PL') {
  // 		event.preventDefault();
  // 	}
  // }
  getColSpan() {
    return this.displayedColumns.indexOf("Soluongchungtu")
  }
  getTotalNumber() {
    let total = 0;
    this.tmpChiTietDNNK.forEach(element => {
      total += Number(element.SoLuongThucNhap)
    });
    return total;
  }
  getTotalNumber2() {
    let total = 0;
    this.tmpChiTietDNNK.forEach(element => {
      total += Number(element.KhoiLuongQuyDoi)
    });
    return total;
  }

  /*----------------- Create Form with appropriate sub forms ---------------*/
  createForm() {
    /*Get name of người lập phiếu */
    var tenNguoiLap = '';
    this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

    var idUser = '';
    this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
    this.DNNKItem.Nguoitao = +idUser;

    var phongban = '';
    this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
    /*Group các Form */
    this.DNNKForm = this.DNNKFB.group({
      SoPhieu: ['', Validators.required],
      NgayLapPhieu: [new Date(), Validators.required],
      TenNguoiLap: [tenNguoiLap],
      TrangThai: [this.nameState],
      LoaiPhieu: ['', Validators.required],
      LyDoCode: ['', Validators.required],
      LyDoKhac: [''],
      PBDeNghi: ['' + phongban, Validators.required],
      //NgayNhapKho: [new Date(), Validators.required],
      PBNhap: ['', Validators.required],
      BPNhap: [''],
      GiaiDoanHH: [''],
      Lydonhap: [''],
      ManufacturingDate: [this.minDate, Validators.required],
      NgayNhanHang: [new Date()],
      ChungTuKemTheo: [true],
      SoChungTu: [''],
      MaKhachHang: [''],
      TenKhachHang: [''],
    });
    if (this.listState.length > 0) {
      this.checkState();
    }

    /*Disable các trường dữ liệu không thay đổi */
    this.DNNKForm.controls["SoPhieu"].disable();
    this.DNNKForm.controls["NgayLapPhieu"].disable();
    this.DNNKForm.controls["TenNguoiLap"].disable();
    this.DNNKForm.controls["TrangThai"].disable();
    this.DNNKForm.controls["TenKhachHang"].disable();

    /*------------------------------------------------------------------*/

    this.HHForm = this.HHFB.group({
      MaHang: ['', Validators.required],
      TenHang: [''],
      QuyCach: [''],
      DVT: [''],
      Solo: ['', Validators.required],
      SoLuong: [DeNghiNhapKho.DEFAULT_NUMBER_VALUE,
      Validators.compose([Validators.required,
      Validators.pattern(this.CONFIG.REGEX_FORMAT_NUMBER_NOTREQUIREDNEW)])
      ],
      GhiChu: [''],
      SoMay: [''],
      ExpiryDate: [null],
      TagInfo: [null],
      PalletText: ['PL'],
      NCC: [''],
      SoXeSoMe: [''],
      SoPOKH: [''],
      SoPONCC: [''],
      LenhSX: [''],
      NgayDongThung: [''],
      MaThung: [''],
      OBJTHCP: [null]
    });

    /*Disable các trường dữ liệu không thay đổi */
    this.HHForm.controls["TenHang"].disable();
    this.HHForm.controls["QuyCach"].disable();
    this.HHForm.controls["DVT"].disable();

    /*------------------------------------------------------------------*/

    this.ImportHHForm = this.ImportFB.group({
      FileDuLieu: [''],
    });
    /*------------------------------------------------------------------*/

    this.changeDetectView();
  }
  bindingValueAfterCallAPIDetail() {
    if (this.DNNKItem.IdDn > 0) {
      if (!this.isCopy) {
        this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
      }
      else {
        this.DNNKItem.IdDn = 0;
        this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
        this.DNNKItem.listChiTietNhapKho.forEach(x => {
          x.IdCtdn = 0;
          x.isDone = false;
          x.DaLapPhieuNhapKho = false;
          x.Nguoikiemtra = 0;
          x.Ngaykiemtra = '';
          x.Quyetdinhlohang = -1;
          x.SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
        })

        this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
          if (res.status == 1) {
            this.DNNKItem.Sophieu = res.data;
            if (this.DNNKForm != null)
              this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
          }
        });
      }
      var tenNguoiLap = '';
      this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });
      if (this.DNNKItem.LyDoCode == "") {
        this.DNNKItem.LyDoCode = "9999";
      }
      var idUser = '';
      this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
      var phongban = 0;
      this.tokenStorage.getCoCauId().subscribe(t => { phongban = parseInt(t); });
      //this.DNNKItem.BoPhanDeNghi = phongban
      //this.DNNKItem.Nguoitao = +idUser;
      this.DNNKItem.BoPhanDeNghi = this.DNNKItem.BoPhanDeNghi
      this.DNNKItem.Nguoitao = this.DNNKItem.Nguoitao;
      this.DNNKForm.controls["NgayLapPhieu"].setValue(this.DNNKItem.Ngaytao);
      this.DNNKForm.controls["TenNguoiLap"].setValue(this.DNNKItem.TenNguoitao);
      this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
      //this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
      this.DNNKForm.controls["PBDeNghi"].setValue(this.DNNKItem.BoPhanDeNghi.toString());
      this.DNNKForm.controls["PBNhap"].setValue(this.DNNKItem.PhongBanNhap.toString());
      this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
      this.DNNKForm.controls["GiaiDoanHH"].setValue(this.DNNKItem.QTSX_GiaiDoan_Id.toString());
      this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
      this.DNNKForm.controls["LyDoCode"].setValue(this.DNNKItem.LyDoCode);
      this.DNNKForm.controls["LyDoKhac"].setValue(this.DNNKItem.LyDo);
      this.DNNKForm.controls["ChungTuKemTheo"].setValue(this.DNNKItem.ChungTuKemTheo);
      this.DNNKForm.controls["SoChungTu"].setValue(this.DNNKItem.SoChungTu);
      this.changeReason(this.DNNKItem.LyDoCode)
      this.checkState();
      this.checkPB();

      /*Add dữ liệu chi tiết*/
      if (this.DNNKItem.listChiTietNhapKho.length > 0) {
        this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
        this.tmpChiTietDNNK = [];

        if (this.listDVT.length > 0) {
          this.filteredListDVT.next(this.listDVT.slice());
        }
        for (let i = 0; i < this.listChiTietDNNK.length; i++) {
          this.listChiTietDNNK[i].IdLo = null;
          if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
            this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
          }
          let tmpElement = new DeNghiNhapKhoChiTiet();
          tmpElement.copy(this.listChiTietDNNK[i])
          if (tmpElement.isDisableHH) {
            tmpElement.isError = true;
            tmpElement.messageError = "Hàng hóa đang chọn hiện không tồn tại!"
          }
          if (this.isCopy) {
            tmpElement.Dvt = this.listChiTietDNNK[i].DvtCopy;
            tmpElement.DvtQuyDoi = this.listChiTietDNNK[i].DvtCopy;

          }
          this.tmpChiTietDNNK.push(tmpElement);
          let filterTmp = new ReplaySubject<any[]>(1)
          filterTmp.next(this.listNCC.slice());
          this.arrayNCCForEachHH.push(filterTmp);
        }

        this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
        this.beforeTmpChiTietDNNK = JSON.parse(JSON.stringify(this.tmpChiTietDNNK));
      }
      this.loadDivisionOptions(this.DNNKItem.PhongBanNhap.toString(), false)

    }
  }
  bindingValueAfterGetDataLenhSanXuat() {
    this.DNNKItem.IdDn = 0;
    this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
    this.DNNKItem.listChiTietNhapKho.forEach(x => {
      x.IdCtdn = 0;
      x.isDone = false;
      x.DaLapPhieuNhapKho = false;
      x.Nguoikiemtra = 0;
      x.Ngaykiemtra = '';
      x.Quyetdinhlohang = -1;
    })

    this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
      if (res.status == 1) {
        this.DNNKItem.Sophieu = res.data;
        if (this.DNNKForm != null)
          this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
      }
    });

    this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
    //this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
    this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
    this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
    this.checkState();
    this.checkPB();

    /*Add dữ liệu chi tiết*/
    if (this.DNNKItem.listChiTietNhapKho.length > 0) {
      this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
      this.tmpChiTietDNNK = [];
      for (let i = 0; i < this.listChiTietDNNK.length; i++) {
        if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
          this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
        }
        let tmpElement = new DeNghiNhapKhoChiTiet();
        tmpElement.copy(this.listChiTietDNNK[i])
        this.tmpChiTietDNNK.push(tmpElement);
      }

      this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    }

    localStorage.removeItem("DataDNNKSource");
  }
  getTitle(): string {
    if (this.DNNKItem.IdDn > 0 && !this.isCopy) {
      return `Chỉnh sửa phiếu đề nghị nhập kho`;
    }
    return 'Thêm mới phiếu đề nghị nhập kho';
  }
  /* -----------------------------------------------------------------------*/


  /*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
  showColumnsInTable() {
    for (let i = 0; i < this.availableColumns.length; i++) {
      if (this.availableColumns[i].isShow == false) {
        this.selectedColumns.toggle(this.availableColumns[i]);
      }
    }
  }
  findIndexColumn(column: string) {
    for (let i = 0; i < this.availableColumns.length; i++) {
      if (this.availableColumns[i].name == column)
        return i;
    }
  }
  dragStarted(event: CdkDragStart, column: string) {
    this.previousIndex = this.findIndexColumn(column);
  }
  dropListDropped(event: CdkDropList, column: string) {
    if (event) {
      moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
      this.applySelectedColumns();
    }
  }
  applySelectedColumns() {
    let _selectedColumns = this.selectedColumns.selected;
    this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
    for (let i = 0; i < this.availableColumns.length; i++) {
      this.selectedColumns.toggle(this.availableColumns[i]);
      for (let j = 0; j < _selectedColumns.length; j++) {
        if (this.availableColumns[i].name == _selectedColumns[j].name) {
          this.selectedColumns.toggle(this.availableColumns[i]);
          break;
        }
      }
    }
    const _applySelectedColumns: string[] = [];
    this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
    this.displayedColumns = _applySelectedColumns;
  }
  /* -----------------------------------------------------------------------*/

  getTree() {
    this.treeService.Get_CoCauToChuc().subscribe(res => {
      if (res.data && res.data.length > 0) {
        this.datatree.next(res.data);
        this.orgStructureTree = res.data[0] ? this.balanceStructureTree(res.data[0], []) : [];
        this.ftrImportDepartment.next([...this.orgStructureTree]);
        this.ftrRequestDepartment.next([...this.orgStructureTree]);
        if (this.DNNKItem.IdDn > 0) {
          this.loadDivisionOptions(this.DNNKItem.PhongBanNhap.toString(), false)
        }
        this.changeDetectView();
      }
    });
  }
  balanceStructureTree(data, orgStructureTree: any[], level: number = 0) {
    if (!data) return;
    if (data) {
      if (level > 0) { // .. Loại bỏ Cty TNHH thực phẩm NFC
        orgStructureTree.push({
          Id_PB: data["Id_PB"],
          TenPB: data["TenPB"]
        });
      }
      if (data.Childrens && data.Childrens.length > 0) {
        data.Childrens.forEach(child => {
          this.balanceStructureTree(child, orgStructureTree, level + 1);
        })
      }
    }
    return orgStructureTree;
  }
  selectedNodePBDeNghi(val: any) {
    this.DNNKForm.controls['PBDeNghi'].setValue('' + val.Id_PB);

  }
  selectedNodeBPNhap(val: any) {
    this.DNNKForm.controls['BPNhap'].setValue('' + val.Id_PB);
  }
  /*------------------------- Hàm lấy danh sách-----------------------------*/
  ListState() {
    this.dungChungService.listState(DeNghiNhapKho.category_path).subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listState = res.data;
        this.checkState();
        this.changeDetectView();
      };
    });
  }
  checkState() {
    this.listState.forEach(element => {
      if (element.Code == this.DNNKItem.Tinhtrang) {
        this.nameState = element.Description;
        if (this.DNNKForm != null)
          this.DNNKForm.controls["TrangThai"].setValue(this.nameState);
      }
    });
  }

  loadListDMHangHoaLite(keyword: string = "", loaiHHId: any = []) {
    this.loadingMerchandise.next(true);
    this.dungChungService.getHHListDM(keyword, loaiHHId).subscribe(res => {
      if (res && res.status === 1) {
        this.listId_HH = res.data;
        this.sumRecord = this.listId_HH.length;
        this.filteredId_HH.next(this.listId_HH.slice());
      }
      this.loadingMerchandise.next(false);
    })
  }

  ListId_HH(keyword: string = "", top: number = 0) {
    this.loadingMerchandise.next(true);
    this.dungChungService.top_list_of_merchandise_lite(keyword, top).subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listId_HH = res.data;
        this.sumRecord = this.listId_HH.length;
        this.filteredId_HH.next(this.listId_HH.slice());
        this.changeDetectView();
      };
      this.loadingMerchandise.next(false);
    });
  }
  filterId_HH(searchTmp: string = '') {
    if (!this.listId_HH) {
      return;
    }
    // get the search keyword
    let search = this.Id_HHFilterCtrl;
    if (searchTmp != '' && searchTmp != null)
      search = '' + searchTmp;

    if (!search) {
      this.sumRecord = this.listId_HH.length;
      this.filteredId_HH.next(this.listId_HH.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    if (searchTmp != '') {
      this.sumRecord = this.listId_HH.filter(ts => ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
      this.filteredId_HH.next(
        this.listId_HH.filter(ts =>
          ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
      );
    }
    else {
      this.sumRecord = this.listId_HH.filter(ts => ts.MaHH.toLowerCase().indexOf(search) > -1).length;
      this.filteredId_HH.next(
        this.listId_HH.filter(ts =>
          ts.MaHH.toLowerCase().indexOf(search) > -1)
      );
    }

    this.changeDetectView();
  }
  afterSelectHH(value: string) {
    this.listId_HH.forEach(element => {
      if (element.Id_HH == +value) {
        /* Added list unit of mer sort dvt3, dvt3, dvt
          required: nếu mã hàng có đơn vị cấp 2 thì ưu tiên hiện cấp 2, nếu có cấp 3 thì ưu tiên hiện cấp 3 cho thêm mới DNNK
        */
        //this.HHForm.controls["DVT"].enable();


        let listDVTHH = []
        listDVTHH.push(element.DVT);
        if (element.Dvt2 != null && element.Dvt2 > 0) {
          listDVTHH.push(element.Dvt2);
          //this.HHForm.controls["DVT"].setValue('' + element.Dvt2);
        }
        if (element.Dvt3 != null && element.Dvt3 > 0) {
          listDVTHH.push(element.Dvt3)
          //this.HHForm.controls["DVT"].setValue('' + element.Dvt3);
        }
        //Mặc định load dvt theo dvt thống kê
        // switch(element.DVTThongKeTon) {
        // 	case 1:
        // 		this.HHForm.controls["DVT"].setValue('' + element.DVT);
        // 		break;
        // 	case 2:
        // 		this.HHForm.controls["DVT"].setValue('' + element.Dvt2);
        // 		break;
        // 	case 3:
        // 		this.HHForm.controls["DVT"].setValue('' + element.Dvt3);
        // 		break;
        // 	default:
        // 		this.HHForm.controls["DVT"].setValue('' + element.DVT);
        // }
        this.HHForm.controls["DVT"].setValue('' + element.DVT);
        // Added infor of mer
        this.selectId_HH = value;
        this.HHForm.controls["MaHang"].setValue(element.MaHH);
        this.HHForm.controls["MaHang"].disable();
        this.HHForm.controls["TenHang"].setValue(element.TenHH);
        this.HHForm.controls["QuyCach"].setValue(element.QuyCach);
        if (element.IdLoaiHH == 4 && this.isNHSX()) {
          this.HHForm.controls["NgayDongThung"].setValue(new Date());

        }
        // if((element.TenNhomHH && element.TenNhomHH.includes('NVL')) || 
        // 	(element.TenNhomHH && element.TenNhomHH.includes('HC')) || 
        // 	+element.IdLoaiHH == 3){
        // 		this.HHForm.controls["DVT"].setValue('' + listDVTHH[listDVTHH.length - 1]);
        // }else if((element.TenNhomHH && element.TenNhomHH.includes('BB - Nylon')) ||
        // 	+element.IdLoaiHH == 1 || +element.IdLoaiHH == 2 ){
        // 	this.HHForm.controls["DVT"].setValue('' + element.DVT);
        // }

        this.filteredListDVT.next(this.listDVT.filter(ts => listDVTHH.reverse().indexOf(ts.Id_DVT) > -1));
        this.calcExpiryDate(+value);
      }
    });
    this.isDisableButton();
  }
  clearSelectHH(event: any) {
    this.selectId_HH = '';
    this.searchWithKeyword();
    this.HHForm.controls["MaHang"].setValue('');
    this.HHForm.controls["MaHang"].enable();

    this.HHForm.controls["TenHang"].setValue('');
    this.HHForm.controls["QuyCach"].setValue('');
    this.HHForm.controls["DVT"].setValue('');
    this.HHForm.controls["DVT"].disable();
    this.HHForm.controls["ExpiryDate"].setValue(null);
    this.HHForm.controls["NgayDongThung"].setValue(null);

    this.sumRecord = this.listId_HH.length;
    this.filteredListDVT.next(this.listDVT.slice());
    if (event != null)
      event.stopPropagation();
    this.isDisableButton();
  }
  onPalletTextChange(index: any) {
    let newValue = this.tmpChiTietDNNK[index].PalletText;
    if (newValue != undefined) {
      if (!newValue.toString().includes("PL")) {
        this.tmpChiTietDNNK[index].PalletText = "PL" + newValue;
      }
    }
    if (this.tmpChiTietDNNK[index].PalletText != "PL") {
      this.tmpChiTietDNNK[index].XacThucPallet = "Chờ quét pallet"
    }
    else {
      this.tmpChiTietDNNK[index].XacThucPallet = ""
    }
    this.changeDetectView();
  }
  // .. Đối tượng THCP
  ListObjTHCP(keyword: string = "", top: number = 0) {
    const THANHPHAM = 4;
    this.loadingObjTHCP.next(true);
    //this.spinnerHH = true;
    //this.KhoDeNghiXuatKhoSubForm.controls["OBJTHCP"].disable();
    this.dungChungService.top_list_of_merchandise_lite(keyword, top).subscribe((res) => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listObjTHCP = res.data;
        this.filteredObjTHCP.next(this.listObjTHCP.slice());
        //this.KhoDeNghiXuatKhoSubForm.controls["OBJTHCP"].enable();
      }
      this.changeDetect.detectChanges();
      this.loadingObjTHCP.next(false);
      this.loadingSubject.next(true);
    });
  }
  filterObjTHCP() {
    this.searchObjTHCP.next(this.objTHCPFilterCtrl);
    this.changeDetectView();
  }
  changeObjTHCP(value: string) {
    let controls = this.HHForm.controls;
    this.listObjTHCP.forEach((obj) => {
      if (obj.Id_HH == +value) {
        this.selectObjTHCP = value;
        controls["OBJTHCP"].setValue(obj.MaHH);
        controls["OBJTHCP"].disable();
      }
    });
    this.isDisableButton();
  }
  nameOfObjTHCP(onlyCode: boolean = true) {
    if (!this.listObjTHCP || this.listObjTHCP.length == 0) return "";
    var obj = this.listObjTHCP.find(x => x.Id_HH == Number(this.selectObjTHCP));
    return (!this.selectObjTHCP || !obj) ? "" : (onlyCode ? obj.MaHH : obj.MaHH + " - " + obj.TenHH);
  }
  clearObjTHCP() {
    let controls = this.HHForm.controls;
    this.filterObjTHCP();
    this.selectObjTHCP = "";
    this.objTHCPFilterCtrl = "";
    this.searchObjTHCP.next(this.objTHCPFilterCtrl);
    controls["OBJTHCP"].setValue("");
    this.filteredObjTHCP.next(this.listObjTHCP.slice());
    controls["OBJTHCP"].enable();
    this.changeDetect.detectChanges();
  }
  ListPB() {
    this.dungChungService.listPhongBanAll().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listPB = res.data;
        this.filteredPB.next(this.listPB.slice());

        var phongban = '';
        this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

        if (this.DNNKItem.IdDn > 0) {
          this.listPB.forEach(element => {
            if (element.Id_PB == +this.DNNKItem.BoPhanDeNghi) {
              this.PBUser = element.Id_PB.toString();
            }
          })
        }
        else {
          this.listPB.forEach(element => {
            if (element.Id_PB == +phongban) {
              this.PBUser = element.Id_PB.toString();
            }
          })
        }
        //this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
        this.changeDetectView();
      };
    });
  }
  filterPB() {
    if (!this.listPB) {
      return;
    }
    let search = this.PBFilterCtrl;
    if (!search) {
      this.filteredPB.next(this.listPB.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredPB.next(
      this.listPB.filter(ts =>
        ts.TenPB.toLowerCase().indexOf(search) > -1)
    );
    this.changeDetectView();
  }
  checkPB() {
    this.listPB.forEach(element => {
      if (element.Id_PB == this.DNNKItem.BoPhanDeNghi) {
        this.PBUser = element.Id_PB.toString();
        if (this.DNNKForm != null)
          this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())

      }
    });
  }

  ListBoPhan() {
    this.dungChungService.listBoPhanLv3All().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listBP = res.data;
        this.filteredBP.next(this.listBP.slice());
        this.changeDetectView();
      };
    });
  }
  filterBoPhan() {
    if (!this.listBP) {
      return;
    }
    let search = this.BPFilterCtrl;
    if (!search) {
      this.filteredBP.next(this.listBP.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBP.next(
      this.listBP.filter(ts =>
        ts.TenPB.toLowerCase().indexOf(search) > -1)
    );
    this.changeDetectView();
  }
  clearBoPhanNhap(event: any) {
    this.DNNKForm.controls["BPNhap"].setValue('');
    event.stopPropagation();
    this.changeDetectView();
  }


  ListGDHH() {
    this.dungChungService.listGiaiDoanHangHoa().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listGDHH = res.data;
        this.filteredGDHH.next(this.listGDHH.slice());
        this.changeDetectView();
      };
    });
  }
  filterGDHH() {
    if (!this.listGDHH) {
      return;
    }
    let search = this.GDHHFilterCtrl;
    if (!search) {
      this.filteredGDHH.next(this.listGDHH.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredGDHH.next(
      this.listGDHH.filter(ts =>
        ts.Ten.toLowerCase().indexOf(search) > -1)
    );
    this.changeDetectView();
  }
  clearGDHH(event: any) {
    this.DNNKForm.controls["GiaiDoanHH"].setValue('');
    event.stopPropagation();
    this.changeDetectView();
  }
  ListLyDo() {

    this.dungChungService.listReasonsWarehouse(DeNghiNhapKho.DEFAULT_LYDO).subscribe(res => {
      if (res && res.status === 1) {
        this.listLyDo = res.data;
        console.log(this.listLyDo)
        this.filteredlistLyDo.next(this.listLyDo.slice());
      };
    });
  }
  changeReason(value) {
    var key = value;
    let form = this.DNNKForm.controls;
    //Xử lý lý do
    if (key && key.includes(DeNghiNhapKho.DEFAULT_LYDOHTNCC)) {
      // this.HHForm.controls["NgaySanXat"].setValidators([Validators.required]);
      // this.HHForm.controls['NgaySanXat'].updateValueAndValidity()
      this.HHForm.controls["NCC"].setValidators([Validators.required]);
      this.HHForm.controls["NCC"].updateValueAndValidity()
      //this.HHForm.controls["SoPOKH"].setValidators([Validators.required]);
      //this.HHForm.controls["SoPOKH"].updateValueAndValidity()

    }
    else {

      this.HHForm.controls["NCC"].setValidators([]);
      this.HHForm.controls["NCC"].updateValueAndValidity()
      //this.HHForm.controls["SoPOKH"].setValidators([]);
      //this.HHForm.controls["SoPOKH"].updateValueAndValidity()
    }
    // .. Xử lý do lý do 'Khác'
    if (key && key.includes(DeNghiNhapKho.DEFAULT_LYDOKHAC)) {
      form['LyDoKhac'].setValidators([Validators.required]);
      setTimeout(() => this.otherReason.first.nativeElement.focus(), 500);
    }
    else {
      form['LyDoKhac'].clearValidators();
      form['LyDoKhac'].setValue("");
    }
    form['LyDoKhac'].updateValueAndValidity();
    const controls = this.HHForm.controls;
    Object.keys(controls).forEach(controlName =>
      controls[controlName].markAsTouched()
    );
    this.isDisableButton();
    this.changeDetect.detectChanges();
  }
  changeChungTuKemTheo(value) {
    var key = value;
    let form = this.DNNKForm.controls;

    // .. Xử lý do lý do 'Khác'
    if (key.checked) {
      form['ChungTuKemTheo'].setValidators([Validators.required]);
      setTimeout(() => this.coChungTu.first.nativeElement.focus(), 500);
    }
    else {
      form['SoChungTu'].clearValidators();
      form['SoChungTu'].setValue("");
    }
    form['SoChungTu'].updateValueAndValidity();
    this.changeDetect.detectChanges();
  }
  isSelectedCoChungTu() {
    let form = this.DNNKForm.controls;
    let value = form["ChungTuKemTheo"].value;
    return value;
  }
  // .. kiểm tra check chọn lý do khác
  isSelectedOtherReason() {
    let form = this.DNNKForm.controls;
    let value = form["LyDoCode"].value;
    return value && value == DeNghiNhapKho.DEFAULT_LYDOKHAC;
  }
  ListLoaiPhieu() {
    this.dungChungService.layDanhSachLoaiPhieu(DeNghiNhapKho.DEFAULT_LOAIPHIEU).subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {

        this.listLoaiPhieu = res.data;
        this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());

        let item = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[1].value)
        if (this.DNNKItem.IdDn > 0 || this.isFromPurchaseOrder) {
          item = this.listLoaiPhieu.find(x => x.Id == this.DNNKItem.LoaiPhieu)
        }

        let index = this.listLoaiPhieu.findIndex(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[3].value)
        if (item != null && this.DNNKForm != null) {
          this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
          this.changeLyDo();
        }
        if (index > -1) {
          this.listLoaiPhieu.splice(index, 1);
          this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
        }
        if (this.isNHSX()) {
          //this.HHForm.controls["ExpiryDate"].setValidators([Validators.required]);
          //this.HHForm.controls["ExpiryDate"].updateValueAndValidity()
          this.DNNKForm.controls["ManufacturingDate"].setValidators([Validators.required]);
          this.DNNKForm.controls["ManufacturingDate"].updateValueAndValidity()
        }
        this.changeDetectView();
      };
    });
  }
  filterLoaiPhieu() {
    if (!this.listLoaiPhieu) {
      return;
    }
    let search = this.LoaiPhieuFilterCtrl;
    if (!search) {
      this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredLoaiPhieu.next(
      this.listLoaiPhieu.filter(ts =>
        ts.Ten.toLowerCase().indexOf(search) > -1)
    );
    this.changeDetectView();
  }
  changeLoaiPhieu() {
    if (this.isNHSX()) {
      this.DNNKForm.controls["ManufacturingDate"].setValidators([Validators.required]);
      this.DNNKForm.controls["ManufacturingDate"].updateValueAndValidity()
    }
    else {
      this.DNNKForm.controls["ManufacturingDate"].setValidators([]);
      this.DNNKForm.controls["ManufacturingDate"].updateValueAndValidity()
    }

    if (this.isLoaiPhieuHTVTKH()) {
      this.DNNKForm.controls["MaKhachHang"].setValidators([Validators.required]);
      this.DNNKForm.controls["MaKhachHang"].updateValueAndValidity()
    } else {
      this.DNNKForm.controls["MaKhachHang"].setValidators([]);
      this.DNNKForm.controls["MaKhachHang"].updateValueAndValidity()
    }
    if (this.isLoaiPhieuHTNCC()) {
      this.HHForm.controls["SoPONCC"].setValidators([Validators.required]);
      this.HHForm.controls["SoPONCC"].updateValueAndValidity()
    }
    else {
      this.DNNKForm.controls["MaKhachHang"].setValidators([]);
      this.DNNKForm.controls["MaKhachHang"].updateValueAndValidity()
    }
    if (this.isLoaiPhieuNTTSX()) {
      this.HHForm.controls["OBJTHCP"].setValidators([Validators.required]);
      this.HHForm.controls["OBJTHCP"].updateValueAndValidity()
    } else {
      this.HHForm.controls["OBJTHCP"].setValidators([]);
      this.HHForm.controls["OBJTHCP"].updateValueAndValidity()
    }
    this.HHForm.reset();
    this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);

    //this.HHForm.controls["NgaySanXat"].setValue(new Date())
    this.HHForm.controls["ExpiryDate"].setValue(null);
    this.changeLyDo()

    this.isDisableButton();
    this.clearSelectHH(null);
    this.changeDetectView();
  }
  changeLyDo() {
    let value = +this.DNNKForm.controls["LoaiPhieu"].value;
    let item = this.listLoaiPhieu.find(x => x.Id == value)
    if (item != null) {
      if (item.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value || item.Ma == DeNghiNhapKho.optionsLoaiPhieu[4].value) {
        this.DNNKForm.controls["LyDoCode"].setValue("HANGSAUSX")
      }
      if (item.Ma == DeNghiNhapKho.optionsLoaiPhieu[1].value) {
        this.DNNKForm.controls["LyDoCode"].setValue("HDNTLK")
      }
      if (item.Ma == DeNghiNhapKho.optionsLoaiPhieu[2].value) {
        this.DNNKForm.controls["LyDoCode"].setValue("HTNCC")
      }
      if (item.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value) {
        this.DNNKForm.controls["LyDoCode"].setValue("HTVTKH")
      }
      this.changeReason(this.DNNKForm.controls["LyDoCode"].value)
    }
    return
  }
  isNHSX() {
    let value = +this.DNNKForm.controls["LoaiPhieu"].value;
    let item = this.listLoaiPhieu.find(x => x.Id == value)
    if (item != null)
      return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value;
    return false;
  }
  isLoaiPhieuNTTSX() {
    let value = +this.DNNKForm.controls["LoaiPhieu"].value;
    let item = this.listLoaiPhieu.find(x => x.Id == value)
    if (item != null)
      return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[1].value;
    return false;
  }

  isLyDoHTNCC() {
    return this.DNNKForm.controls["LyDoCode"].value == DeNghiNhapKho.DEFAULT_LYDOHTNCC;
  }
  isLoaiPhieuHTNCC() {
    let value = +this.DNNKForm.controls["LoaiPhieu"].value;
    let item = this.listLoaiPhieu.find(x => x.Id == value);
    if (item != null) {
      return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[2].value;
    }
    return false;
  }
  isLoaiPhieuHTVTKH() {
    let value = +this.DNNKForm.controls["LoaiPhieu"].value;
    let item = this.listLoaiPhieu.find(x => x.Id == value)
    if (item != null)
      return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value;
    return false;
  }
  ListDVT() {
    this.dungChungService.getDSDonViTinh().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listDVT = res.data;
        this.filteredListDVT.next(this.listDVT.slice());
        this.changeDetectView()
      };
    });
  }
  filterDVT() {
    if (!this.listDVT) {
      return;
    }
    let search = this.ListDVTFilterCtrl;

    if (this.HHForm.controls["MaHang"].value != null &&
      this.HHForm.controls["MaHang"].value != '') {

      let item = this.listId_HH.find(x => x.Id_HH == +this.selectId_HH);
      if (item != null) {
        var listDVTHH = []
        listDVTHH.push(item.DVT);
        if (item.Dvt2 != null && item.Dvt2 > 0)
          listDVTHH.push(item.Dvt2);
        if (item.Dvt3 != null && item.Dvt3 > 0)
          listDVTHH.push(item.Dvt3);

        if (!search) {
          this.filteredListDVT.next(
            this.listDVT.filter(ts => listDVTHH.indexOf(ts.Id_DVT) > -1)
          );
          return;
        } else {
          search = search.toLowerCase();
        }
        this.filteredListDVT.next(
          this.listDVT.filter(ts =>
            listDVTHH.indexOf(ts.Id_DVT) > -1 &&
            ts.TenDVT.toLowerCase().indexOf(search) > -1)
        );
      }
      else {
        if (!search) {
          this.filteredListDVT.next(this.listDVT.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        this.filteredListDVT.next(
          this.listDVT.filter(ts =>
            ts.TenDVT.toLowerCase().indexOf(search) > -1)
        );
      }
    }
    else {
      if (!search) {
        this.filteredListDVT.next(this.listDVT.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
      this.filteredListDVT.next(
        this.listDVT.filter(ts =>
          ts.TenDVT.toLowerCase().indexOf(search) > -1)
      );
    }

    this.changeDetectView();
  }
  changeDVTItem(index) {
    let _detail = this.tmpChiTietDNNK[index];
    if (_detail) {
      _detail.Soluongchungtu = '' + Number(_detail.KhoiLuongQuyDoi);
      // if(_detail.listDVTInfo && _detail.listDVTInfo.length > 0){
      // 	let currentDVT = _detail.listDVTInfo.find(x => x.IdDVT == _detail.DvtQuyDoi)
      // 	if(currentDVT){
      // 		_detail.Soluongchungtu = '' + (Number(_detail.KhoiLuongQuyDoi) * Number(currentDVT.QuyDoiDVT))
      // 	}
      // }
      this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
      this.changeDetectView();
    }
  }

  ListTagKho() {
    this.dungChungService.listTagKho().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listTagFull = res.data;
        this.listTag = res.data.map(x => x.tagkho);
        this.filteredTags.next(this.listTag.slice())
        this.changeDetectView()
      };
    });
  }
  /*----------------------------Danh sach khach hang --------------------------------*/
  async loadListKhachHang() {
    var res = await this.dungChungService.layDanhSachKhachHang().toPromise();
    if (res.data != null && res.status === 1) {
      this.listId_KH = res.data;
      this.sumRecord_KH = this.listId_KH.length;
      this.filteredId_KH.next(this.listId_KH.slice());
      if (this.tmpChiTietDNNK.length > 0) {
        this.arrayKHForEachHH = [];
        this.tmpChiTietDNNK.forEach(_x => {
          var _customers = new ReplaySubject<any[]>(1);
          this.arrayKHForEachHH.push(_customers.next(this.listId_KH.slice()));
        });
      }
    }
    else {
      this.filteredId_KH.next([]);
    }
  }

  filterId_KH(searchTmp: string = '') {
    if (!this.listId_KH) {
      return;
    }
    if (searchTmp === '') {
      this.sumRecord_KH = this.listId_KH.length;
      this.filteredId_KH.next(this.listId_KH.slice());
      return;
    }
    else {
      searchTmp = searchTmp.toLowerCase();
      this.sumRecord_KH = this.listId_KH.filter(ts => ts.Makh.toLowerCase().includes(searchTmp) || ts.Tenkh.toLowerCase().includes(searchTmp)).length;
      this.filteredId_KH.next(this.listId_KH.filter(ts => ts.Makh.toLowerCase().includes(searchTmp) || ts.Tenkh.toLowerCase().includes(searchTmp)));
    }
  }
  afterSelectKH(value: string) {
    const controls = this.DNNKForm.controls;
    this.listId_KH.forEach(element => {
      if (element.IdKh === +value) {
        this.selectedId_KH = Number(value);
        controls["MaKhachHang"].setValue(element.Makh);
        controls["TenKhachHang"].setValue(element.Tenkh);
        controls["MaKhachHang"].disable();
        //controls["GHICHU"].setValue("Xuất kho cho "+ element.Tenkh)
        this.bindValueDienGiai()
      }
    });

  }
  clearSelectKH(event: any) {
    const controls = this.DNNKForm.controls;
    this.selectedId_KH = 0;
    controls["MaKhachHang"].enable();
    controls["MaKhachHang"].setValue('');
    controls["TenKhachHang"].setValue('');

    event.stopPropagation();
  }
  ListNCC() {
    this.dungChungService.listNCC().subscribe(res => {
      this.loadingSubject.next(false);
      if (res && res.status === 1) {
        this.listNCC = res.data;
        this.filteredNCC.next(this.listNCC.slice());
        this.changeDetectView();
      };
    });
  }
  filterNCC() {
    if (!this.listNCC) {
      return;
    }
    let search = this.NCCFilterCtrl;
    if (!search) {
      this.filteredNCC.next(this.listNCC.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredNCC.next(
      this.listNCC.filter(ts => (ts.MaNCC + ' ' + ts.TenNCC).toLowerCase().indexOf(search) > -1)
    );
    this.changeDetectView();
  }
  filterNCCItem(index) {
    if (!this.listNCC) {
      return;
    }
    let search = this.NCCFilterCtrl;
    if (!search) {
      this.arrayNCCForEachHH[index].next(this.listNCC.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    if (index > -1) {
      this.arrayNCCForEachHH[index].next(this.listNCC.filter(ts => (ts.MaNCC + ' ' + ts.TenNCC).toLowerCase().indexOf(search) > -1));
    }

    this.changeDetectView();
  }
  clearNCC(event: any) {
    this.HHForm.controls["NCC"].setValue('');
    event.stopPropagation();
    this.changeDetectView();
  }
  getTenNCC(item) {
    if (item && item.IdNcc > 0) {
      let obj = this.listNCC.find(x => x.Id_NCC == item.IdNcc);
      return obj ? obj.TenNCC : '';
    }
    return '';
  }
  bindValueDienGiai() {
    let fil = this.tmpChiTietDNNK.filter(x => x.IdNcc > 0);
    if (fil.length > 0) {
      let uniqueArray = [...new Set(fil)];
      let dataDienGiai = 'Nhập kho từ ';
      let dataMap = [];
      uniqueArray.forEach(x => {
        dataMap.push(this.getTenNCC(x))
      })
      this.DNNKForm.controls["Lydonhap"].setValue(dataDienGiai + [...new Set(dataMap)].join(' , '));
    } else {
      let currentLyDo = this.DNNKForm.controls["Lydonhap"].value;
      if (this.DNNKForm.controls["BPNhap"].value) {
        let bp = this.listBP.find(x => x.Id_PB == +this.DNNKForm.controls["BPNhap"].value);
        if (bp) {
          this.DNNKForm.controls["Lydonhap"].setValue('Nhập kho cho ' + bp.TenPB);
        } else {
          this.DNNKForm.controls["Lydonhap"].setValue('');
        }
      } else {
        this.DNNKForm.controls["Lydonhap"].setValue(currentLyDo + '');
      }
    }
  }
  /* -----------------------------------------------------------------------*/


  /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
  showErrorInputSL(columnName: string, formGroup: any, name: string) {
    let message = "";
    let controls = formGroup.controls;
    if (controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
    if (controls[columnName].hasError('maxlength')
      || (controls[columnName].value.length > 22
        && (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
      return 'Tối đa 18 chữ số với 2 chữ số thập phân';
    return message;
  }
  ValidateChangeNumberForm(event: any, isEvent: boolean = true) {
    var count = 0;
    if (isEvent) {
      for (let i = 0; i < event.target.value.length; i++) {
        if (event.target.value[i] == ',') {
          count += 1;
        }
      }
    }
    else {
      event = "" + event
      for (let i = 0; i < event.length; i++) {
        if (event[i] == ',') {
          count += 1;
        }
      }
    }
    var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
    var found = isEvent ? event.target.value.match(regex) : event.match(regex);
    if (found != null) {
      const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
      this.layoutUtilsService.showErorr(message);
      return false;;
    }
    if (count >= 2) {
      const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
      this.layoutUtilsService.showErorr(message);
      return false;;
    }
    return true;
  }
  formatNumber(item: string) {
    if (item == '' || item == null || item == undefined) return '';
    if (typeof (item) === "string") {
      item = item.replace(/,/g, "");
    }
    return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
  }
  formatComparenumber(number: string) {
    return +number.replace(/\./g, "").replace(/,/g, ".");;
  }
  f_currency(value: string): any {
    if (value == null || value == undefined || value == '') value = '0.00';
    let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
    return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
  }
  f_currency_V2(value: string): any {
    if (value == null || value == undefined || value == '') return '';
    let nbr = Number((value + '').replace(/,/g, ""));
    return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  f_currency_VND(value: string): any {
    if (value == null || value == undefined) return DeNghiNhapKho.DEFAULT_NUMBER_VALUE;
    return new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
  }
  f_number(item: any = "0.00") {
    return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
  }
  keyUpInputNumberVND(event) {
    FunctionPublic.cvKeyUp(event);
  }
  keyUpInputNumber(event) {
    FunctionPublic.preventAlphaV3(event);
  }
  changeInputNumberVND(event, columnName, min: number = 0, formGroup) {
    let controls = formGroup.controls;
    let position = event.target.selectionStart;
    let sizeStart = event.target.value.toString().length;
    let sizeEnd = sizeStart;
    var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
    var found = event.target.value.match(regex);
    if (found != null) {
      event.preventDefault();
    }
    else {
      if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

      let data = FunctionPublic.slListChangedV2(event);
      if (data) {
        if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
        controls[columnName].setValue(data);
        sizeEnd = data.toString().length;
        let balance = sizeEnd - sizeStart;
        event.target.selectionStart = position + balance;
        event.target.selectionEnd = position + balance;

        if (data.length == 4) {
          event.target.selectionStart = position;
          event.target.selectionEnd = position;
        }

      } else {
        controls[columnName].setValue(this.f_number((min)));
      }
    }
  }
  changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup) {
    let controls = formGroup.controls;
    if (this.ValidateChangeNumberForm(event)) {
      let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

      if (Number(tmpValue) < min) tmpValue = min;

      if (!controls[controlName].invalid) {
        controls[controlName].setValue(
          this.f_number((tmpValue))
        );
      }
      if (tmpValue.indexOf(',') == 0 && tmpValue.length == 1) {
        tmpValue = min;
      }
      controls[controlName].setValue(
        this.f_number((tmpValue))
      );
    }
    else {
      controls[controlName].setValue(this.f_number((min)));
    }
  }
  changeInputNumberVNDInList(event: any, min: number = 0) {

    let position = event.target.selectionStart;
    let sizeStart = event.target.value.toString().length;
    let sizeEnd = sizeStart;
    var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
    var found = event.target.value.match(regex);
    if (found != null) {
      event.preventDefault();
    }
    else {
      if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9) { return; }

      let data = FunctionPublic.slListChangedV2(event);
      if (data) {
        if (this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
        event.target.value = data;
        sizeEnd = data.toString().length;
        let balance = sizeEnd - sizeStart;
        event.target.selectionStart = position + balance;
        event.target.selectionEnd = position + balance;
        if (data.length == 4) {
          event.target.selectionStart = position;
          event.target.selectionEnd = position;
        }
      } else {
        event.target.value = this.f_number((min));
      }
    }
  }
  changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet) {

    if (event.target.value == "") {
      event.target.value = this.f_number(0);
      event.target.selectionStart = 0;
      event.target.selectionEnd = 0;
    }

    if (event.target.value.toString() == item[columnName].toString()) {
      event.target.value = this.f_number(item[columnName]);
      event.target.selectionStart = 0;
      event.target.selectionEnd = 0;
    }

    if (this.ValidateChangeNumberForm(event)) {
      let tmpValue = event.target.value.replace(/\./g, "").replace(/,/g, ".");

      if (Number(tmpValue) < min) tmpValue = min;

      if (!item[columnName]) {
        item[columnName] = tmpValue.toString();
      }

      if (tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1) {
        tmpValue = min;
      }
      item[columnName] = tmpValue.toString();
    }
    else {
      item[columnName] = min.toString();
    }

    this.changeDetectView();
  }
  cvInputFormNumber(controlName: string, event: any, min: number = 0, formGroup) {
    const VALUE_EMPTY = "";
    const MIN_VALUE = min;
    const REGEX_COMMA = /,/g;
    const VALUE_DEFAULT = 0.00000;
    var controls = formGroup.controls;
    var valueControl = controls[controlName].value;
    // .. Giá trị trống thì lấy giá trị min
    if (valueControl == VALUE_EMPTY) controls[controlName].setValue(this.f_number(MIN_VALUE));
    // .. Giá trị không xác thực gán lại 0.0
    if (isNaN(valueControl)) valueControl = VALUE_DEFAULT;
    // .. Giá trị nhỏ hơn min thì = min
    if (Number(valueControl) < min) valueControl = MIN_VALUE;
    // .. Valid mới set giá trị
    if (!controls[controlName].invalid) controls[controlName].setValue(this.f_number(valueControl));
    // .. Giá trị "," thì gán về min
    if (valueControl.toString().indexOf(REGEX_COMMA) == 0 && valueControl.length == 1) valueControl = MIN_VALUE;
    controls[controlName].setValue(this.f_number(valueControl));
  }
  // .. Hàm sử dụng cho sự kiện change format số trên table
  cvInputListNumber(columnName: string, event: any, min: number = 0, item: any) {
    const VALUE_EMPTY = "";
    const MIN_VALUE = min;
    const REGEX_COMMA = /,/g;
    const INDEX_ZERO = 0;
    const VALUE_DEFAULT = 0.00000;
    var value = item[columnName];
    var evtValue = event.target.value;
    var evtTarget = event.target;
    if ((evtValue == VALUE_EMPTY) || (evtValue.toString() == value.toString())) {
      if (evtValue == VALUE_EMPTY) evtTarget.value = this.f_number(MIN_VALUE);
      if (evtValue.toString() == value.toString()) evtTarget.value = this.f_number(value);
      evtTarget.selectionStart = INDEX_ZERO;
      evtTarget.selectionEnd = INDEX_ZERO;
    }
    if (!this.ValidateChangeNumberForm(event)) {
      item[columnName] = MIN_VALUE;
      return false;
    }
    if (isNaN(evtValue)) evtValue = VALUE_DEFAULT;
    if (Number(evtValue) < min) evtValue = MIN_VALUE;
    if (!item[columnName]) item[columnName] = MIN_VALUE;
    item[columnName] = evtValue;
    evtTarget.value = this.f_number(evtValue);
    this.changeDetect.detectChanges();
  }
  /* -----------------------------------------------------------------------*/


  /*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
  getFormatDate(v: string = '') {
    if (v != null && v != undefined && v != '') {
      return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
    }
    return '';
  }
  f_convertDate(p_Val: any) {
    if (p_Val == null || p_Val == undefined || p_Val == '') return '';
    let a = p_Val === "" ? new Date() : new Date(p_Val);
    return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
  }
  minMaxDate(p_Val: any, item: any) {
    let d1 = new Date(p_Val);
    let d2 = new Date();

    if (d1.getTime() < d2.getTime()) {
      this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Handung = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
      this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    }
    this.changeDetectView();
  }
  /* -----------------------------------------------------------------------*/


  /*---------------------------- Thao tác trên form ------------------------*/
  isDisableButton() {
    if (this.HHForm.invalid ||
      this.HHForm.controls["TenHang"].value == null ||
      this.HHForm.controls["TenHang"].value == '') {
      this.disableNewButton = true;
    }
    else {
      this.disableNewButton = false;
    }
  }
  isChangeTTPhieu() {

    let isChange = false;
    if (this.DNNKItem.IdDn > 0) {

      let item = this.listLoaiPhieu.find(x => x.Id == this.DNNKItem.LoaiPhieu)
      if (item && this.DNNKForm.controls["LoaiPhieu"].value != item.Id.toString()) {
        isChange = true
        return isChange;
      }
      if (+this.DNNKForm.controls["PBDeNghi"].value != this.DNNKItem.BoPhanDeNghi) {
        isChange = true
        return isChange;
      }
      if (+this.DNNKForm.controls["BPNhap"].value != this.DNNKItem.BoPhanNhap) {
        isChange = true
        return isChange;
      }
      if (+this.DNNKForm.controls["GiaiDoanHH"].value != this.DNNKItem.QTSX_GiaiDoan_Id) {
        isChange = true
        return isChange;
      }
      // if(moment(new Date(this.DNNKForm.controls["NgayNhapKho"].value)).format('YYYY-MM-DD')
      // 		!= moment(new Date(this.DNNKItem.Ngaynhap)).format('YYYY-MM-DD')){
      // 	isChange = true
      // 	return isChange;
      // }
      if (this.DNNKForm.controls["Lydonhap"].value != this.DNNKItem.Lydonhap) {
        isChange = true
        return isChange;
      }


      let isAllnew = false;
      this.tmpChiTietDNNK.forEach(x => {
        if (x.IdCtdn == 0) {
          isAllnew = true;
        }
      })
      if (isAllnew && this.DNNKItem.IdDn > 0)
        return true;

      if (this.DNNKItem.listChiTietNhapKho.length != this.tmpChiTietDNNK.length) {
        isChange = true
        return isChange;
      }
    }
    else {
      var phongban = '';
      this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

      let item = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)

      if (this.DNNKForm.controls["LoaiPhieu"].value != item.Id.toString()
        || this.DNNKForm.controls["Lydonhap"].value != null && this.DNNKForm.controls["Lydonhap"].value != ''
        || this.DNNKForm.controls["PBDeNghi"].value != phongban
        || (this.DNNKForm.controls["BPNhap"].value != null && this.DNNKForm.controls["BPNhap"].value != '')
        || (this.DNNKForm.controls["GiaiDoanHH"].value != null && this.DNNKForm.controls["GiaiDoanHH"].value != '')
        || this.tmpChiTietDNNK.length > 0) {
        isChange = true;
      }
    }
    return isChange;
  }
  back() {
    if (!this.isChangeTTPhieu()) {
      this.routerBack();
      return;
    }
    const dialogRef = this.layoutUtilsService.POPConfirm('Các thông tin vừa chỉnh sửa sẽ bị mất nếu bạn không lưu lại?');
    dialogRef.afterClosed().subscribe(res => {
      if (!res) return;
      this.routerBack();
    });
  }
  deleteItem(item: any) {
    const index = this.tmpChiTietDNNK.indexOf(item, 0);
    if (index > -1) {
      this.tmpChiTietDNNK.splice(index, 1);
      this.arrayNCCForEachHH.splice(index, 1);
      if (index < this.rowUpdate && this.rowUpdate > -1) this.rowUpdate -= 1;
    }
    this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    this.bindValueDienGiai();
  }
  clearErrorData() {
    for (let i = 0; i < this.tmpChiTietDNNK.length; i++) {
      if (this.tmpChiTietDNNK[i].isError) {
        this.tmpChiTietDNNK.splice(i, 1);
        i--;
      }
    }
    this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
  }
  checkErrorData() {
    for (let i = 0; i < this.tmpChiTietDNNK.length; i++) {
      if (this.tmpChiTietDNNK[i].isError) {
        return true;
      }
    }
    return false;
  }
  addDetail() {
    const _detail = new DeNghiNhapKhoChiTiet();
    _detail.clear();

    let index = this.listId_HH.findIndex(x => x.Id_HH == +this.selectId_HH)
    if (index > -1) {
      _detail.MaHH = this.listId_HH[index].MaHH;
      _detail.TenHH = this.listId_HH[index].TenHH;
      _detail.QuyCach = this.listId_HH[index].QuyCach;
      _detail.SoXeSoMe = this.HHForm.controls["SoXeSoMe"].value;
      _detail.SoPOKH = this.HHForm.controls["SoPOKH"].value;
      _detail.SoPONCC = this.HHForm.controls["SoPONCC"].value;
      _detail.LenhSX = this.HHForm.controls["LenhSX"].value;
      //Save khối lượng + đơn vị tính chọn trên form
      _detail.DvtQuyDoi = +this.HHForm.controls["DVT"].value;
      _detail.KhoiLuongQuyDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))
      _detail.MaThung = this.HHForm.controls["MaThung"].value;
      //Quy đổi DVT chọn thành DVT cấp 1 để lưu và xử lý Kho - Qui ước là Kg, # Kg tự chịu
      _detail.listDVTInfo = [];
      _detail.listDVTInfo.push(
        {
          IdDVT: this.listId_HH[index].Dvt3,
          TenDVT: this.listId_HH[index].TenDVT3,
          QuyDoiDVT: this.listId_HH[index].QuiDoiDVT3
        },
        {
          IdDVT: this.listId_HH[index].Dvt2,
          TenDVT: this.listId_HH[index].TenDVT2,
          QuyDoiDVT: this.listId_HH[index].QuiDoiDVT2
        },
        {
          IdDVT: this.listId_HH[index].DVT,
          TenDVT: this.listId_HH[index].TenDVT,
          QuyDoiDVT: 1
        }
      )
      _detail.Dvt = _detail.listDVTInfo[2].IdDVT;
      _detail.listDVTInfo = _detail.listDVTInfo.filter(x => x.IdDVT) // remove null
      let listIdHH = _detail.listDVTInfo.map(x => x.IdDVT);
      _detail.listDVTInfo = _detail.listDVTInfo.filter((e, i) => listIdHH.indexOf(e.IdDVT) === i);
      let currentDVT = _detail.listDVTInfo.find(x => x.IdDVT == _detail.DvtQuyDoi)
      if (currentDVT) {
        _detail.TenDvtQuyDoi = currentDVT.TenDVT
        _detail.Soluongchungtu = '' + (Number(_detail.KhoiLuongQuyDoi) * Number(currentDVT.QuyDoiDVT))
      }
    }
    const doiTuongData = this.listObjTHCP.find(x => x.Id_HH == this.selectObjTHCP);
    const selectedDoiTuong = this.selectObjTHCP || false;
    const nameObjectTCP = selectedDoiTuong ? doiTuongData.MaHH + " - " + doiTuongData.TenHH : "";

    _detail.IdHh = +this.selectId_HH;
    _detail.Solo = this.HHForm.controls["Solo"].value;
    _detail.Ghichulohang = this.HHForm.controls["GhiChu"].value;
    _detail.IdNcc = +this.HHForm.controls["NCC"].value;
    _detail.SoMay = this.HHForm.controls["SoMay"].value;
    _detail.PalletText = this.HHForm.controls["PalletText"].value;
    _detail.DoiTuongTHCP = selectedDoiTuong ? Number(this.selectObjTHCP) : null;
    _detail.TenDoiTuongTHCP = nameObjectTCP;
    if (_detail.PalletText != "PL") {
      _detail.XacThucPallet = "Chờ quét pallet"
    }
    if (this.selectedTag && this.selectedTag.length > 0) {
      _detail.TagInfo = this.selectedTag;
    }

    /* 	remove NgaySanXuat of HHForm
      use ManufacturingDate of DNNKForm apply date all for details
      ---------------------------------------------------------
      if(this.HHForm.controls["NgaySanXat"].value != null && this.HHForm.controls["NgaySanXat"].value != '')
        _detail.NgaySanXat = moment(new Date(this.HHForm.controls["NgaySanXat"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    */
    if (this.DNNKForm.controls["ManufacturingDate"].value != null && this.DNNKForm.controls["ManufacturingDate"].value != '')
      _detail.NgaySanXat = moment(new Date(this.DNNKForm.controls["ManufacturingDate"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    if (this.isLoaiPhieuHTNCC()) {
      if (this.DNNKForm.controls["NgayNhanHang"].value != null && this.DNNKForm.controls["NgayNhanHang"].value != '')
        _detail.NgayNhanHang = moment(new Date(this.DNNKForm.controls["NgayNhanHang"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    }
    if (this.isNHSX()) {
      if (this.HHForm.controls["NgayDongThung"].value != null && this.HHForm.controls["NgayDongThung"].value != '')
        _detail.NgayDongThung = moment(new Date(this.HHForm.controls["NgayDongThung"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    }
    // add ExpiryDate value
    if (this.HHForm.controls["ExpiryDate"].value != null && this.HHForm.controls["ExpiryDate"].value != '') {
      let exp = new Date(this.HHForm.controls["ExpiryDate"].value);
      exp.setHours(23, 59, 59, 59)
      _detail.ExpiryDate = moment(exp).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    }
    // .. add name and code cncc
    if (_detail.IdNcc && Number(_detail.IdNcc) > 0) {
      var _data = this.getCodeAndNameCompany(Number(_detail.IdNcc));
      if (_data) {
        _detail.MaNCC = _data["MaNCC"];
        _detail.TenNCC = _data["TenNCC"];
      }
    }
    const message = `Thông tin hàng đề nghị nhập kho đã được thêm.`;
    this.layoutUtilsService.showInfo(message);

    this.HHForm.reset();
    this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
    this.HHForm.controls["MaHang"].enable(); //Open field when reset
    //this.HHForm.controls["NgaySanXat"].setValue(new Date());
    this.HHForm.controls["ExpiryDate"].setValue(null);
    this.HHForm.controls["Solo"].setValue(_detail.Solo);
    if (_detail.IdNcc > 0)
      this.HHForm.controls["NCC"].setValue(_detail.IdNcc + '');

    this.HHForm.controls["DVT"].setValue('');
    this.HHForm.controls["DVT"].disable();
    this.filteredListDVT.next(this.listDVT.slice());

    this.selectId_HH = '';
    this.filteredId_HH.next(this.listId_HH.slice());

    this.selectedTag = [];
    this.filteredTags.next(this.listTag.slice());
    //By pass bước cộng dồn nếu cùng hàng vì vướng DVT khác nhau
    if (this.rowUpdate < 0) {
      this.tmpChiTietDNNK.push(_detail);
      this.saveAddedCT.push(this.tmpChiTietDNNK.findIndex(x => x == _detail));
    }
    else {
      this.updateDataRow(_detail);
      this.saveAddedCT.push(this.rowUpdate);
      this.rowUpdate = -1;
    }
    //Case cộng dồn nếu cùng hàng
    // let indexDetail = this.tmpChiTietDNNK.findIndex(x => x.IdHh == _detail.IdHh
    // 											&& x.Solo == _detail.Solo
    // 											&& x.SoMay == _detail.SoMay
    // 											&& moment(new Date(x.NgaySanXat)).format('YYYY-MM-DD')
    // 											== moment(new Date(_detail.NgaySanXat)).format('YYYY-MM-DD'));
    // if(indexDetail > -1){
    // 	this.tmpChiTietDNNK[indexDetail].Soluongchungtu = '' +
    // 		(Number(_detail.Soluongchungtu) + Number(this.tmpChiTietDNNK[indexDetail].Soluongchungtu));
    // 	this.tmpChiTietDNNK[indexDetail].Ghichulohang = _detail.Ghichulohang;
    // }
    // else{
    // 	this.tmpChiTietDNNK.push(_detail);
    // 	this.saveAddedCT.push(this.tmpChiTietDNNK.findIndex(x => x == _detail));
    // }

    this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    this.disableNewButton = true;

    let filterTmp = new ReplaySubject<any[]>(1)
    filterTmp.next(this.listNCC.slice());
    this.arrayNCCForEachHH.push(filterTmp);
    let fil = this.tmpChiTietDNNK.filter(x => x.IdNcc > 0);
    if (fil.length > 0) {
      let uniqueArray = [...new Set(fil)];
      let dataDienGiai = 'Nhập kho từ ';
      let dataMap = [];
      uniqueArray.forEach(x => {
        dataMap.push(this.getTenNCC(x))
      })
      this.DNNKForm.controls["Lydonhap"].setValue(dataDienGiai + [...new Set(dataMap)].join(' , '));
    }
    //this.bindValueDienGiai();
    this.scrollToBottom();
    this.changeDetectView();
  }
  preventPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    if (!/^\d+$/.test(pastedText)) {
      event.preventDefault();
    }
  }
  onSubmit(type: number) {
    const controls = this.DNNKForm.controls;

    if (this.DNNKForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      if (this.DNNKForm.controls['LyDoCode'].value == "") {
        this.layoutUtilsService.showErorr('Vui lòng chọn lý do nhập kho');
        this.scrollToTop();
        return null;
      }
      //document.getElementById('dialog-form').scrollTo({ top: 0, behavior: 'smooth' });
      this.scrollToTop();

      return false;
    }

    if (this.tmpChiTietDNNK.length <= 0) {
      this.layoutUtilsService.showErorr('Vui lòng thêm thông tin hàng đề nghị nhập kho');
      this.scrollToBottom();
      return null;
    }

    if (this.checkErrorData()) {
      this.layoutUtilsService.showErorr('Vui lòng kiểm tra lại thông tin hàng đề nghị nhập kho');
      this.scrollToBottom();
      return null;
    }

    for (let i = 0; i < this.tmpChiTietDNNK.length; i++) {
      if (!this.tmpChiTietDNNK[i].isError) {

        if (Number(this.tmpChiTietDNNK[i].Soluongchungtu) <= 0) {
          this.layoutUtilsService.showErorr('Số lượng gốc của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được <= 0');
          this.scrollToBottom();
          return null;
        }
        if (Number(this.tmpChiTietDNNK[i].KhoiLuongQuyDoi) <= 0) {
          this.layoutUtilsService.showErorr('Số lượng quy đổi của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được <= 0');
          this.scrollToBottom();
          return null;
        }
        else if (this.tmpChiTietDNNK[i].Solo == null || this.tmpChiTietDNNK[i].Solo == undefined || this.tmpChiTietDNNK[i].Solo == '' || this.tmpChiTietDNNK[i].Solo.trim() == '') {
          this.layoutUtilsService.showErorr('Số lô của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống');
          this.scrollToBottom();
          return null;
        }

        else if (this.isNHSX() && (this.tmpChiTietDNNK[i].NgaySanXat == null || this.tmpChiTietDNNK[i].NgaySanXat == undefined || this.tmpChiTietDNNK[i].NgaySanXat == '')) {
          this.layoutUtilsService.showErorr('Ngày sản xuất của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống với loại phiếu nhập hàng sản xuất');
          this.scrollToBottom();
          return null;
        }

        // else if(this.isNHSX() && (this.tmpChiTietDNNK[i].ExpiryDate == null || this.tmpChiTietDNNK[i].ExpiryDate == undefined || this.tmpChiTietDNNK[i].ExpiryDate == '')){
        // 	this.layoutUtilsService.showErorr('Hạn sử dụng của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống với loại phiếu nhập hàng sản xuất');
        // 	this.scrollToBottom();
        // 	return null;
        // }

        else if (this.tmpChiTietDNNK[i].ExpiryDate && this.tmpChiTietDNNK[i].NgaySanXat
          && (moment(new Date(this.tmpChiTietDNNK[i].NgaySanXat)).format('YYYY-MM-DD[T]HH:mm:ss.SSS') > moment(new Date(this.tmpChiTietDNNK[i].ExpiryDate)).format('YYYY-MM-DD[T]HH:mm:ss.SSS'))) {
          this.layoutUtilsService.showErorr('Ngày sản xuất của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được lớn hơn Hạn sử dụng');
          this.scrollToBottom();
          return null;
        }
        if (this.isLoaiPhieuHTNCC() && (this.tmpChiTietDNNK[i].SoPONCC == null || this.tmpChiTietDNNK[i].SoPONCC == undefined || this.tmpChiTietDNNK[i].SoPONCC == '' || this.tmpChiTietDNNK[i].SoPONCC.trim() == '')) {
          this.layoutUtilsService.showErorr('Số PO NCC của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống');
          this.scrollToBottom();
          return null;
        }
        if (this.isLoaiPhieuHTNCC() && (this.tmpChiTietDNNK[i].IdNcc == null || this.tmpChiTietDNNK[i].IdNcc == undefined || this.tmpChiTietDNNK[i].IdNcc == 0)) {
          this.layoutUtilsService.showErorr('Nhà cung cấp của mã hàng ' + this.tmpChiTietDNNK[i].MaHH + ' không được để trống');
          this.scrollToBottom();
          return null;
        }
      }
      // Format date in the list of detail to moment
      if (this.tmpChiTietDNNK[i].NgaySanXat) this.tmpChiTietDNNK[i].NgaySanXat = moment(new Date(this.tmpChiTietDNNK[i].NgaySanXat)).format('YYYY-MM-DD[T]HH:mm:ss');
      if (this.tmpChiTietDNNK[i].NgayDongThung) this.tmpChiTietDNNK[i].NgayDongThung = moment(new Date(this.tmpChiTietDNNK[i].NgayDongThung)).format('YYYY-MM-DD[T]HH:mm:ss');
      if (this.tmpChiTietDNNK[i].ExpiryDate) this.tmpChiTietDNNK[i].ExpiryDate = moment(new Date(this.tmpChiTietDNNK[i].ExpiryDate)).format('YYYY-MM-DD[T]HH:mm:ss');
      // Format number for the DVTQuyDoi
      if (this.tmpChiTietDNNK[i].DvtQuyDoi) this.tmpChiTietDNNK[i].DvtQuyDoi = +this.tmpChiTietDNNK[i].DvtQuyDoi;
    }

    const _result = new DeNghiNhapKho();
    _result.clear();
    _result.Sophieu = controls["SoPhieu"].value;
    //_result.Ngaynhap = moment(new Date(controls["NgayNhapKho"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
    _result.Ngaytao = moment(new Date(controls["NgayLapPhieu"].value)).format('YYYY-MM-DD[T]HH:mm:ss.SSS'); // tmp Value but insert today in API
    _result.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
    _result.LoaiPhieu = +controls["LoaiPhieu"].value;
    _result.BoPhanDeNghi = +controls["PBDeNghi"].value;
    _result.BoPhanNhap = +controls["BPNhap"].value;
    _result.PhongBanNhap = +controls["PBNhap"].value
    _result.QTSX_GiaiDoan_Id = +controls["GiaiDoanHH"].value;
    _result.Lydonhap = controls["Lydonhap"].value;
    _result.LyDoCode = controls["LyDoCode"].value;
    _result.SoChungTu = controls["SoChungTu"].value;
    _result.ChungTuKemTheo = controls["ChungTuKemTheo"].value;
    if (this.DNNKItem.Nguoitao) {
      _result.Nguoitao = this.DNNKItem.Nguoitao;
    }
    if (this.isLoaiPhieuHTVTKH()) {
      _result.IdKh = this.selectedId_KH;
    }
    if (_result.LyDoCode != DeNghiNhapKho.DEFAULT_LYDOKHAC) {
      _result.LyDo = this.listLyDo.find(x => x.key == _result.LyDoCode).value
    }
    else {
      _result.LyDo = controls["LyDoKhac"].value;
      _result.LyDoCode = '';
    }
    _result.isCreateQT = this.DNNKItem.isCreateQT;

    if (type == 1 || type == 2) {
      _result.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[4].value;
    }

    _result.listChiTietNhapKho = this.tmpChiTietDNNK;
    _result.listChiTietNhapKho.forEach(item => {
      if (item.PalletText == "PL") {
        item.PalletText = ""
      }

      if (this.isLoaiPhieuHTNCC()) {
        item.SoPOKH = "";
      }
      else {
        item.SoPONCC = "";
      }
      let beforeItem = this.beforeTmpChiTietDNNK.find(x => x.IdCtdn === item.IdCtdn);
      if (beforeItem && JSON.stringify(beforeItem) !== JSON.stringify(item)) {
        item.isUpdated = true;
      }

    });
    _result.listChiTietNhapKho = [..._result.listChiTietNhapKho];
    if (type == 1 || type == 2) {
      const dialogRef = this.layoutUtilsService.POP02(_result.Sophieu);
      dialogRef.afterClosed().subscribe(res => {
        if (!res) {
          return;
        }
        if (this.DNNKItem.IdDn > 0) {
          _result.IdDn = this.DNNKItem.IdDn;
          _result.BoPhanDeNghi = this.DNNKItem.BoPhanDeNghi;
          this.update(_result, type);
          return;
        }
        if (this.isFromPurchaseOrder) {
          this.addFromPurchaseOrder(_result, type);
          return;
        }
        this.add(_result, type);
      });
    }
    else {
      if (this.DNNKItem.IdDn > 0) {
        _result.IdDn = this.DNNKItem.IdDn;
        this.update(_result, type);
        return;
      }
      if (this.isFromPurchaseOrder) {
        this.addFromPurchaseOrder(_result, type);
        return;
      }
      this.add(_result, type);
    }
  }
  update(item: DeNghiNhapKho, withBack: number) {
    this.onLoadingXX();
    this.deNghiNhapKhoService.updatWithDetail(item).subscribe(res => {
      if (res.status == 1) {
        const message = `Phiếu đề nghị nhập kho cập nhật thành công`;
        this.layoutUtilsService.showInfo(message);
        this.selectedId_KH = null;
        let index = this.saveAdded.findIndex(x => x == res.data.IdDn);
        if (index == -1)
          this.saveAdded.push(res.data.IdDn);
        this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

        if (withBack == 1) {
          this.routerBack();
        }
        else {
          this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
          this.clearDataImport();

          if (withBack == 2) {
            this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(resNextSP => {
              if (resNextSP.status == 1) {

                this.DNNKForm.reset();

                var tenNguoiLap = '';
                this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

                var phongban = '';
                this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

                this.DNNKForm.controls["SoPhieu"].setValue(resNextSP.data);
                this.DNNKForm.controls["NgayLapPhieu"].setValue(new Date());
                this.DNNKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
                //this.DNNKForm.controls["NgayNhapKho"].setValue(new Date());
                this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
                let item = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
                if (item != null && this.DNNKForm != null) {
                  this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
                }

                this.listPB.forEach(element => {
                  if (element.Id_PB == +phongban) {
                    this.PBUser = element.Id_PB.toString();
                  }
                })
                this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser);

                /*Disable các trường dữ liệu không thay đổi */
                this.DNNKForm.controls["SoPhieu"].disable();
                this.DNNKForm.controls["NgayLapPhieu"].disable();
                this.DNNKForm.controls["TenNguoiLap"].disable();
                this.DNNKForm.controls["TrangThai"].disable();

                this.HHForm.reset();
                this.HHForm.controls["MaHang"].enable();
                this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
                this.HHForm.controls["NgaySanXat"].setValue(new Date());
                this.sumRecord = this.listId_HH.length;
                this.ImportHHForm.reset();

                this.listChiTietDNNK = [];
                this.tmpChiTietDNNK = [];
                this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

                this.DNNKItem.IdDn = 0;
                this.DNNKItem.Sophieu = resNextSP.data;
                this.title = this.getTitle();
              }
              else {
                const message = `Lỗi lấy số phiếu tiếp theo`;
                this.layoutUtilsService.showErorr(message);
              }
            });
          }

          else if (withBack == 3) {
            this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
              if (res.status == 1) {
                this.DNNKItem = res.data;
                this.DNNKItem.isCreateQT = true;
                if (this.DNNKItem.listChiTietNhapKho.length > 0) {
                  this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
                  this.tmpChiTietDNNK = [];
                  this.filteredListDVT.next(this.listDVT.slice());

                  for (let i = 0; i < this.listChiTietDNNK.length; i++) {
                    if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
                      this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
                    }
                    let tmpElement = new DeNghiNhapKhoChiTiet();
                    tmpElement.copy(this.listChiTietDNNK[i])
                    this.tmpChiTietDNNK.push(tmpElement);

                  }

                  this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
                  this.beforeTmpChiTietDNNK = JSON.parse(JSON.stringify(this.tmpChiTietDNNK));

                }
                this.changeDetectView();
              }
            });
            this.isCopy = false;
          }
        }
      }
      else {
        this.layoutUtilsService.showErorr(res.error.message);
      }
      this.offLoadingXX();
    });
  }
  add(item: DeNghiNhapKho, withBack: number) {
    this.onLoadingXX();
    this.deNghiNhapKhoService.add(item).subscribe(res => {
      if (res.status == 1) {
        const message = `Phiếu đề nghị nhập kho mới đã được thêm.`;
        this.layoutUtilsService.showInfo(message);
        this.selectedId_KH = null
        let index = this.saveAdded.findIndex(x => x == res.data.IdDn);
        if (index == -1)
          this.saveAdded.push(res.data.IdDn);
        this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

        res.data.listChiTietNhapKho.forEach(element => {
          let index = this.tmpChiTietDNNK.findIndex(x => x.IdCtdn == element.IdCtdn);
          if (index > -1) {
            this.tmpChiTietDNNK[index].IdLo = element.IdLo;
          }
        })

        if (withBack == 1) {
          this.routerBack();
        }
        else {

          this.selectId_HH = '';
          this.filteredId_HH.next(this.listId_HH.slice());
          this.clearDataImport();

          if (withBack == 2) {
            this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
              if (res.status == 1) {

                this.DNNKForm.reset();

                var tenNguoiLap = '';
                this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

                var phongban = '';
                this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

                this.DNNKForm.controls["SoPhieu"].setValue(res.data);
                this.DNNKForm.controls["NgayLapPhieu"].setValue(new Date());
                this.DNNKForm.controls["TenNguoiLap"].setValue(tenNguoiLap);
                //this.DNNKForm.controls["NgayNhapKho"].setValue(new Date());
                this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
                let item = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
                if (item != null && this.DNNKForm != null) {
                  this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
                }

                this.listPB.forEach(element => {
                  if (element.Id_PB == +phongban) {
                    this.PBUser = element.Id_PB.toString();
                  }
                })
                this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser);
                /*Disable các trường dữ liệu không thay đổi */
                this.DNNKForm.controls["SoPhieu"].disable();
                this.DNNKForm.controls["NgayLapPhieu"].disable();
                this.DNNKForm.controls["TenNguoiLap"].disable();
                this.DNNKForm.controls["TrangThai"].disable();

                this.HHForm.reset();
                this.HHForm.controls["MaHang"].enable();
                this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
                this.HHForm.controls["NgaySanXat"].setValue(new Date());
                this.HHForm.controls["ExpiryDate"].setValue(new Date());
                this.HHForm.controls["Solo"].setValue(this.tmpChiTietDNNK[this.tmpChiTietDNNK.length - 1].Solo);

                this.sumRecord = this.listId_HH.length;
                this.ImportHHForm.reset();

                this.listChiTietDNNK = [];
                this.tmpChiTietDNNK = [];
                this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

                this.filteredListDVT.next(this.listDVT.slice());

                this.DNNKItem.Sophieu = res.data;
                this.changeDetectView();
              }
              else {
                const message = `Lỗi lấy số phiếu tiếp theo`;
                this.layoutUtilsService.showErorr(message);
              }
            });
          }
          else if (withBack == 3) {
            this.DNNKForm.controls["TrangThai"].setValue(DeNghiNhapKho.optionsTinhTrang[0].name);
            this.DNNKItem.IdDn = res.data.IdDn;
            this.deNghiNhapKhoService.getItemById(this.DNNKItem.IdDn).subscribe(res => {
              if (res.status == 1) {
                this.DNNKItem = res.data;
                this.DNNKItem.isCreateQT = true;
                if (this.DNNKItem.listChiTietNhapKho.length > 0) {
                  this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
                  this.tmpChiTietDNNK = [];
                  this.filteredListDVT.next(this.listDVT.slice());

                  for (let i = 0; i < this.listChiTietDNNK.length; i++) {
                    if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
                      this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
                    }
                    let tmpElement = new DeNghiNhapKhoChiTiet();
                    tmpElement.copy(this.listChiTietDNNK[i])
                    this.tmpChiTietDNNK.push(tmpElement);
                  }

                  this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
                  this.beforeTmpChiTietDNNK = JSON.parse(JSON.stringify(this.tmpChiTietDNNK));

                }
                this.changeDetectView();
              }
            });
            this.isCopy = false;
          }
          this.title = this.getTitle();
        }
      }
      else {
        this.layoutUtilsService.showErorr(res.error.message);
      }
      this.offLoadingXX();
    });
  }
  addFromPurchaseOrder(item: DeNghiNhapKho, withBack: number) {
    this.onLoadingXX();
    this.deNghiNhapKhoService.createForPurchaseOrder(item).subscribe(res => {
      if (res.status == 1) {
        const message = `Phiếu đề nghị nhập kho mới đã được thêm.`;
        this.layoutUtilsService.showInfo(message);
        this.dialogRef.close({ data: res.data });
      } else {
        const message = res.error && res.error.message ? res.error.message : 'Có lỗi xảy ra khi tạo phiếu đề nghị nhập kho từ đơn hàng mua.';
        this.layoutUtilsService.showErorr(message);
        this.offLoadingXX && this.offLoadingXX();
      }
    });
  }
  openHistoryDialog(item: DeNghiNhapKhoChiTiet) {
    const dialogRef = this.dialog.open(DNNKLSNhapKhoDialogComponent, {
      data: {
        data: item.IdCtdn,
        MaHH: item.MaHH,
        TenHH: item.TenHH
      },
      maxHeight: '90vh',
      width: '90vw'
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == undefined || res == null) {
        return;
      }
    });
  }
  QuiDoiHint() {
    const _detail = new DeNghiNhapKhoChiTiet();
    _detail.clear();
    let index = this.listId_HH.findIndex(x => x.Id_HH == +this.selectId_HH)
    if (index > -1) {
      _detail.MaHH = this.listId_HH[index].MaHH;
      _detail.TenHH = this.listId_HH[index].TenHH;
      _detail.QuyCach = this.listId_HH[index].QuyCach;

      //Save khối lượng + đơn vị tính chọn trên form
      _detail.DvtQuyDoi = +this.HHForm.controls["DVT"].value;
      _detail.KhoiLuongQuyDoi = Number(this.f_number(this.HHForm.controls["SoLuong"].value))

      if (_detail.DvtQuyDoi > 0 && _detail.KhoiLuongQuyDoi > 0) {
        //Quy đổi DVT chọn thành DVT cấp 1 để lưu và xử lý Kho - Qui ước là Kg, # Kg tự chịu
        _detail.listDVTInfo = [];
        _detail.listDVTInfo.push(
          {
            IdDVT: this.listId_HH[index].Dvt3,
            TenDVT: this.listId_HH[index].TenDVT3,
            QuyDoiDVT: this.listId_HH[index].QuiDoiDVT3
          },
          {
            IdDVT: this.listId_HH[index].Dvt2,
            TenDVT: this.listId_HH[index].TenDVT2,
            QuyDoiDVT: this.listId_HH[index].QuiDoiDVT2
          },
          {
            IdDVT: this.listId_HH[index].DVT,
            TenDVT: this.listId_HH[index].TenDVT,
            QuyDoiDVT: 1
          }
        )
        _detail.listDVTInfo = _detail.listDVTInfo.filter(x => x.IdDVT) // remove null
        let listIdHH = _detail.listDVTInfo.map(x => x.IdDVT);
        _detail.listDVTInfo = _detail.listDVTInfo.filter((e, i) => listIdHH.indexOf(e.IdDVT) === i);
        let currentDVT = _detail.listDVTInfo.find(x => x.IdDVT == _detail.DvtQuyDoi)
        _detail.Dvt = _detail.listDVTInfo[0].IdDVT;
        if (currentDVT) {
          _detail.Soluongchungtu = '' + (Number(_detail.KhoiLuongQuyDoi) * Number(currentDVT.QuyDoiDVT))
        }
        return this.f_number(_detail.Soluongchungtu) + ' Kg'
      }
    }
    return '0.00 Kg'
  }
  /* -----------------------------------------------------------------------*/


  /*---------------------- Import file dữ liệu hàng hóa --------------------*/
  selectFile() {
    let el: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
    el.click();
  }
  FileSelected(evt: any) {
    if (evt.target.files && evt.target.files.length) {
      let file = evt.target.files[0];
      let fileName = file.name;
      var res = fileName.match(/.xlsx$/g);
      if (res) {
        if (!res["includes"]('.xlsx')) {
          this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
          return;
        }
        else {
          this.ImportHHForm.controls['FileDuLieu'].patchValue(fileName);
          this.processImport = true;
          this.changeDetectView();
          this.Importfile();
        }
      }
      else {
        this.layoutUtilsService.showErorr('File không hợp lệ, chỉ nhận file định dạng xlsx');
        return;
      }
    }
    else {//Không có file
      this.ImportHHForm.controls['FileDuLieu'].patchValue('');
    }
    evt.target.type = 'text';
    evt.target.type = 'file';
  }
  checkDataIsValid(): boolean {
    let p = document.getElementById("fileUploadExcel");
    return this.ImportHHForm.controls['FileDuLieu'] && this.ImportHHForm.controls['FileDuLieu'].valid && (p ? (p["type"] == 'file' ? p["files"]["length"] > 0 : false) : false);
  }
  Importfile() {
    let el: any = this.fileUploadImport.nativeElement;
    var service = this.deNghiNhapKhoService;

    for (var idx = 0; idx < el.files.length; idx++) {

      var extension = el.files[idx].name.split('.').pop();
      var fileName = el.files[idx].name.substring(0, el.files[idx].name.indexOf(extension) - 1);

      let reader = new FileReader();
      reader.readAsDataURL(el.files[idx]);

      reader.onload = function () {
        let base64Str = reader.result as String;
        var metaIdx = base64Str.indexOf(';base64,');
        base64Str = base64Str.substr(metaIdx + 8);

        var data = {
          fileName: fileName,
          base64: base64Str,
          extension: extension
        };

        service.lastFileUpload$.next(data);
        service.uploadFileImport(data).subscribe(res => {
          if (res && res.status == 1) {
            service.data_import.next(res.data);
          }
          else {
            service.lastFilterDSExcel$.next([]);
            service.lastFilterInfoExcel$.next(undefined);
            return;
          }
        });
      };
    }
  }
  ImportFileMau() {
    let linkdownload = this.deNghiNhapKhoService.downloadTemplate();
    window.open(linkdownload);
  }
  clearDataImport() {
    this.deNghiNhapKhoService.data_import.next([]);
  }
  /* -----------------------------------------------------------------------*/


  /*------------------------------ Extend Options --------------------------*/
  timKiemNangCao() {
    this.openTimKiemNangCao = true;

    const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
      data: {
        kw: this.focusDetail.first.nativeElement.value
      },
      maxHeight: '90vh',
      width: '90vw'
    });
    dialogRef.afterClosed().subscribe(res => {
      this.openTimKiemNangCao = false;
      if (res == undefined || res == null) {
        return;
      }
      else {
        if (!res.isChange) {
          return;
        }
        if (res.dataAdd.length != 0) {
          this.afterSelectHH(res.dataAdd.toString())
        }
      }
    });
  }
  tabChange(event: MatTabChangeEvent) {
    if (event.index == 0)
      this.flagTab = 0;
    else if (event.index == 1)
      this.flagTab = 1;
    this.clearDataImport();
    this.changeDetectView();
  }
  changeDetectView() {
    if (!(this.changeDetect as ViewRef).destroyed) {
      this.changeDetect.detectChanges()
    }
  }
  scrollToBottom() {
    setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }, 200);
  }

  scrollToTop() {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 200);
  }

  highlightNewestRecord(currentPosition: number) {
    if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
      return true;
    }
    return false;
  }
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key == "Escape") {
    }
    else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_CLOSE.KeyCombine.keycode) {
      this.onSubmit(1);
    }
    else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_AND_NEW.KeyCombine.keycode) {
      this.onSubmit(2);
    }
    else if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.SAVE_TMP.KeyCombine.keycode) {
      this.onSubmit(3);
    }
    this.changeDetectView();
  }
  onLoadingXX() {
    this.waittingLoadingXX = true;
    this.changeDetectView();
  }
  offLoadingXX() {
    this.waittingLoadingXX = false;
    this.changeDetectView();
  }
  searchWithKeyword() {
    //this.loadingMerchandise.next(true);
    this.keywordChanged.next(this.Id_HHFilterCtrl);
    this.changeDetectView();
  }
  triggerMerchandise() {
    return !this.selectId_HH ? "" : this.listId_HH.find(x => x.Id_HH == Number(this.selectId_HH)).MaHH;
  }
  /* -----------------------------------------------------------------------*/

  /* --------------- < Copy data > ---------------*/
  copyData(indexRow: number) {
    if (indexRow < 0) return;
    var listItem = [...this.tmpChiTietDNNK];
    var itemContentCopy = new DeNghiNhapKhoChiTiet();
    itemContentCopy.copy(listItem[indexRow]);
    itemContentCopy.IdCtdn = 0;
    this.tmpChiTietDNNK.push(itemContentCopy);

    let filterTmp = new ReplaySubject<any[]>(1)
    filterTmp.next(this.listNCC.slice());
    this.arrayNCCForEachHH.push(filterTmp);

    this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    this.changeDetectView();
  }
  /* -----------------------------------------------------------------------*/

  /*  when change Manufacturing Date in the level - master
    re-set the min date of expiry date
  */
  changeManufacturingDate() {
    if (!this.DNNKForm || !this.DNNKForm.controls["ManufacturingDate"].value) return;
    if (this.selectId_HH) this.calcExpiryDate(+this.selectId_HH);
    this.changeDetectView();
  }
  /* -----------------------------------------------------------------------*/

  /*  function calc ExpiryDate from "Danh mục" menu
    in: idhh, out: expirydate
    lấy trường "thời hạn sử dụng" để tính toán - nếu = 0 thì để trống
  */
  calcExpiryDate(idhh: number = 0) {
    if (!idhh || !this.DNNKForm || !this.DNNKForm.controls['ManufacturingDate'].value) return;
    let mftDate = new Date(this.DNNKForm.controls['ManufacturingDate'].value);
    let month = this.listId_HH.find(x => +x.Id_HH == idhh).HanDung;
    if (!month || month == 0) return;

    // Add months
    let expirydate = new Date(mftDate.setMonth(mftDate.getMonth() + month));

    // Subtract 1 day
    expirydate.setDate(expirydate.getDate() - 1);

    // Set to end of day
    expirydate.setHours(23, 59, 59, 59);

    this.HHForm.controls["ExpiryDate"].setValue(expirydate);
    this.changeDetectView();
  }
  // .. Tải file mẫu
  downloadTemplateImport() {
    this.loadingDownloadTemplate.next(true);
    this.deNghiNhapKhoService.downloadTemplateImport().subscribe((blob) => {
      var downloadLink = document.createElement("a");
      var url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = "FILE_MAU_DENGHINHAPKHO";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      this.loadingDownloadTemplate.next(false);
      this.changeDetectView();
    });
  }
  // .. Mở cửa sổ chọn file
  openSelectFile() {
    if (this.tmpChiTietDNNK.length > 0) {
      const dialogRef = this.layoutUtilsService.POPConfirm("Bạn có muốn xóa hết thông tin chi tiết trước khi chọn file ?");
      dialogRef.afterClosed().subscribe(res => {
        if (res) {
          this.tmpChiTietDNNK = [];
          this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
          this.bindValueDienGiai()
        }
        var inputFile: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
        inputFile.click();
      });
    }

    else {
      var inputFile: HTMLElement = this.fileUploadImport.nativeElement as HTMLElement;
      inputFile.click();
    }
  }
  // .. Xác thực file
  validateFileSelected(evt: any) {
    if (evt.target.files && evt.target.files.length) {
      const EXTENSION_VALID = ".xlsx";
      let file = evt.target.files[0];
      let fileName = file.name;
      var res = fileName.match(/.xlsx$/g);
      var error = 'File không hợp lệ, chỉ nhận file định dạng xlsx';
      if (!res || !res["includes"](EXTENSION_VALID)) {
        this.layoutUtilsService.showErorr(error);
        return;
      }
      this.startImportFile();
    }
    evt.target.type = 'text';
    evt.target.type = 'file';
  }
  // .. Lấy dữ liệu file đã chọn, xử lý, gửi đến server
  startImportFile() {
    var id: any = this.fileUploadImport.nativeElement;
    var service = this.deNghiNhapKhoService;
    for (var idx = 0; idx < id.files.length; idx++) {
      this.loadingImportFile.next(true);
      var extension = id.files[idx].name.split(".").pop();
      var indexExtension = id.files[idx].name.indexOf(extension);
      var fileName = id.files[idx].name.substring(0, indexExtension - 1);
      var data = { fileName: fileName, extension: extension };
      var reader = new FileReader();
      var changeView = this.changeDetect;
      var self = this;
      reader.readAsDataURL(id.files[idx]);
      reader.onload = function () {
        var base64Str = reader.result as String;
        var metaIdx = base64Str.indexOf(";base64,");
        base64Str = base64Str.substring(metaIdx + 8);
        data = { ...data, ...{ base64: base64Str } };
        service.startImportFile(data).subscribe((res) => {
          self.afterImportExcel(res);
          changeView.detectChanges();
        });
      };
    }
  }
  // .. Hàm xử lý sau khi upload file & nhận json từ server
  afterImportExcel({ status, data }) {
    if (status == 0) {
      this.loadingImportFile.next(false);
      this.layoutUtilsService.showErorr("Lỗi: không thể import file.");
      return;
    }
    if (data.errors && data.errors.length > 0) this.layoutUtilsService.warningImportDNXK(data.errors);
    data.data.forEach(_x => {
      var _item = new DeNghiNhapKhoChiTiet();
      _item.clear();
      _item.IdHh = _x.IdHh ? Number(_x.IdHh) : 0;
      _item.MaHH = _x.MaHH ? _x.MaHH : "";
      _item.TenHH = _x.TenHH ? _x.TenHH : "";
      _item.QuyCach = _x.QuyCach ? _x.QuyCach : "";
      _item.SoPOKH = _x.SoPOKH ? _x.SoPOKH : "";
      _item.SoPONCC = _x.SoPONCC ? _x.SoPONCC : "";
      _item.LenhSX = _x.LenhSX ? _x.LenhSX : "";
      _item.DvtQuyDoi = _x.DvtQuyDoi ? Number(_x.DvtQuyDoi) : 0;
      _item.KhoiLuongQuyDoi = _x.KhoiLuongQuyDoi ? Number(_x.KhoiLuongQuyDoi) : 0;
      _item.Solo = _x.Solo ? _x.Solo : "";
      _item.Ghichulohang = _x.Ghichulohang ? _x.Ghichulohang : "";
      _item.IdNcc = _x.IdNcc ? Number(_x.IdNcc) : 0;
      _item.MaNCC = _x.MaNCC ? _x.MaNCC : "";
      _item.TenNCC = _x.TenNCC ? _x.TenNCC : "";
      _item.SoMay = _x.SoMay ? _x.SoMay : "";
      _item.PalletText = _x.PalletText ? _x.PalletText : "PL";
      _item.TagInfo = _x.TagInfo && _x.TagInfo.length > 0 ? _x.TagInfo : [];
      _item.NgaySanXat = _x.NgaySanXat ? moment(new Date(_x.NgaySanXat)).format('YYYY-MM-DD[T]HH:mm:ss.SSS') : null;
      //_item.NgayDongThung 	= _x.NgayDongThung ? moment(new Date(_x.NgayDongThung)).format('YYYY-MM-DD[T]HH:mm:ss.SSS') : null;

      _item.ExpiryDate = _x.ExpiryDate ? moment(new Date(_x.ExpiryDate)).format('YYYY-MM-DD[T]HH:mm:ss.SSS') : null;
      _item.SoXeSoMe = _x.SoXeSoMe ? _x.SoXeSoMe : "";
      _item.MaThung = _x.MaThung ? _x.MaThung : "";
      _item.DoiTuongTHCP = _x.DoiTuongTHCP ? Number(_x.DoiTuongTHCP) : null;
      _item.TenDoiTuongTHCP = _x.TenDoiTuongTHCP ? _x.TenDoiTuongTHCP : "";
      // .. Thêm 3 cấp đơn vị tính
      _item.listDVTInfo = [
        {
          IdDVT: _x.Dvt3 ? Number(_x.Dvt3) : null,
          TenDVT: _x.TenDvt3,
          QuyDoiDVT: _x.DvtQuiDoi3 ? Number(_x.DvtQuiDoi3) : null
        },
        {
          IdDVT: _x.Dvt2 ? Number(_x.Dvt2) : null,
          TenDVT: _x.TenDvt2,
          QuyDoiDVT: _x.DvtQuiDoi2 ? Number(_x.DvtQuiDoi2) : null
        },
        {
          IdDVT: _x.Dvt ? Number(_x.Dvt) : null,
          TenDVT: _x.TenDvt,
          QuyDoiDVT: 1
        }
      ];
      _item.messageError = _x.messageError;
      _item.isError = _x.isError;
      _item.isDisableHH = _x.isDisableHH;
      _item.Dvt = _item.listDVTInfo[2].IdDVT;
      _item.TenDvtQuyDoi = _x.TenDvt;
      _item.listDVTInfo = _item.listDVTInfo.filter(x => x.IdDVT) // remove null
      _item.listDVTInfo = _item.listDVTInfo.filter((e, i) => _item.listDVTInfo.map(x => x.IdDVT).indexOf(e.IdDVT) === i);
      let currentDVT = _item.listDVTInfo.find(x => x.IdDVT == _item.DvtQuyDoi)
      if (currentDVT) _item.Soluongchungtu = '' + (Number(_item.KhoiLuongQuyDoi) * Number(currentDVT.QuyDoiDVT));
      this.tmpChiTietDNNK.push(_item);
    });
    this.loadingImportFile.next(false);
    this.layoutUtilsService.showInfo("Import thành công!");
    this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
    this.bindValueDienGiai();

    this.changeDetectView();
  }

  // .. Chỉnh sửa dữ liệu chi tiết
  editItem(index: number) {
    if (index > -1) {
      var row = { ...this.tmpChiTietDNNK[index] };
      // .. Lấy danh sách data hàng hóa
      this.Id_HHFilterCtrl = row.MaHH;
      this.keywordChanged.next(this.Id_HHFilterCtrl);
      this.scrollToTop();
      setTimeout(() => {
        // .. Khai báo form
        var formControl = this.HHForm.controls;
        var masterControl = this.DNNKForm.controls;
        // .. Fill data
        formControl["MaHang"].setValue(Number(row.IdHh));
        formControl["TenHang"].setValue(row.TenHH);
        formControl["QuyCach"].setValue(row.QuyCach);
        formControl["DVT"].setValue('' + Number(row.DvtQuyDoi));
        formControl["Solo"].setValue(row.Solo);
        formControl["SoLuong"].setValue(Number(row.KhoiLuongQuyDoi));
        formControl["ExpiryDate"].setValue(row.ExpiryDate);
        formControl["NgayDongThung"].setValue(row.NgayDongThung);
        formControl["SoMay"].setValue(row.SoMay);
        formControl["MaThung"].setValue(row.MaThung);
        formControl["TagInfo"].setValue(row.TagInfo);
        formControl["GhiChu"].setValue(row.Ghichulohang);
        formControl["SoXeSoMe"].setValue(row.SoXeSoMe);
        formControl["SoPOKH"].setValue(row.SoPOKH);
        formControl["LenhSX"].setValue(row.LenhSX);
        formControl["NCC"].setValue('' + Number(row.IdNcc));
        formControl["PalletText"].setValue(row.PalletText);
        formControl["SoPONCC"].setValue(row.SoPONCC);
        masterControl["ManufacturingDate"].setValue(row.NgaySanXat);
        if (row.DoiTuongTHCP) {
          formControl["OBJTHCP"].setValue(Number(row.DoiTuongTHCP));
        } else {
          formControl["OBJTHCP"].enable();
        }
        formControl["DVT"].enable();
        this.selectId_HH = "" + row.IdHh;
        this.selectObjTHCP = (row.DoiTuongTHCP != null ? row.DoiTuongTHCP.toString() : '');

        this.selectedTag = row.TagInfo;
        this.selectObjTHCP = (row.DoiTuongTHCP != null ? row.DoiTuongTHCP.toString() : '');
        this.rowUpdate = index;
        this.setListUnitFromIdHH(Number(row.IdHh));
        this.cvInputFormNumber('SoLuong', null, 0, this.HHForm);
        this.isDisableButton();
        this.changeDetectView();
      }, 1000);
    }
  }
  // .. Lấy danh sách dvt theo idhh
  setListUnitFromIdHH(idhh: number) {
    var listDVTs = []
    if (idhh < 0 || !this.listId_HH || this.listId_HH.length == 0) return listDVTs;
    if (idhh > -1 && this.listId_HH.length > 0)
      var item = this.listId_HH.find(_x => _x.Id_HH == idhh);
    if (!item) return listDVTs;
    if (item != null)
      listDVTs.push(item.DVT);
    if (item.Dvt2 != null && item.Dvt2 > 0) listDVTs.push(item.Dvt2);
    if (item.Dvt3 != null && item.Dvt3 > 0) listDVTs.push(item.Dvt3);
    this.filteredListDVT.next(this.listDVT.filter(ts => listDVTs.reverse().indexOf(ts.Id_DVT) > -1));
  }
  // .. Lấy mã & tên nhà cung cấp
  getCodeAndNameCompany(idncc: number) {
    if (idncc < 0 || !this.listNCC || this.listNCC.length == 0) return "";
    var item = this.listNCC.find(_x => _x.Id_NCC == idncc);
    if (!item) return "";
    return { MaNCC: item.MaNCC, TenNCC: item.TenNCC };
  }
  // .. Update data dòng
  updateDataRow(_newData: DeNghiNhapKhoChiTiet) {
    if (this.rowUpdate < 0) return;
    var _item = this.tmpChiTietDNNK[this.rowUpdate];
    _item.IdHh = _newData.IdHh;
    _item.MaHH = _newData.MaHH;
    _item.TenHH = _newData.TenHH;
    _item.QuyCach = _newData.QuyCach;
    _item.DvtQuyDoi = _newData.DvtQuyDoi;
    _item.KhoiLuongQuyDoi = _newData.KhoiLuongQuyDoi;
    _item.listDVTInfo = _newData.listDVTInfo;
    _item.Dvt = _newData.Dvt;
    _item.Soluongchungtu = _newData.Soluongchungtu;
    _item.Solo = _newData.Solo;
    _item.Ghichulohang = _newData.Ghichulohang;
    _item.IdNcc = _newData.IdNcc;
    _item.SoMay = _newData.SoMay;
    _item.PalletText = _newData.PalletText;
    _item.TagInfo = _newData.TagInfo;
    _item.NgaySanXat = _newData.NgaySanXat;
    _item.ExpiryDate = _newData.ExpiryDate;
    _item.IdNcc = _newData.IdNcc;
    _item.MaNCC = _newData.MaNCC;
    _item.TenNCC = _newData.TenNCC;
    _item.SoPONCC = _newData.SoPONCC;
    _item.SoPOKH = _newData.SoPOKH;
    _item.SoXeSoMe = _newData.SoXeSoMe;
    _item.MaThung = _newData.MaThung;
    _item.NgayDongThung = _newData.NgayDongThung;
    // .. Remove and Add again
    this.tmpChiTietDNNK.splice(this.rowUpdate, 1);
    this.tmpChiTietDNNK.splice(this.rowUpdate, 0, _item);
  }
  // .. Reset form về mặc định
  resetFormControl() {
    this.HHForm.reset();
    this.HHForm.controls["SoLuong"].setValue(DeNghiNhapKho.DEFAULT_NUMBER_VALUE);
    this.HHForm.controls["MaHang"].enable();
    this.HHForm.controls["ExpiryDate"].setValue(null);
    this.HHForm.controls["Solo"].setValue("");
    this.HHForm.controls["NCC"].setValue('')
    this.HHForm.controls["DVT"].setValue('');
    this.HHForm.controls["DVT"].disable();
    this.selectId_HH = '';
    this.selectedTag = [];
    this.filteredListDVT.next(this.listDVT.slice());
    this.filteredId_HH.next(this.listId_HH.slice());
    this.filteredTags.next(this.listTag.slice());
  }

  // .. Hàm lấy mã màu từ tên tag kho
  getBgColorTag(tag: string) {
    var _item = this.listTagFull.find(_x => _x.tagkho == tag);
    return _item == null ? '#ccc' : _item.BackgroundColor;
  }

  // .. Dialog Form
  handleFormDialog() {

    const CONSTANT_COMMA = ",";
    var form = this.DNNKForm.controls;
    // .. Custom UI
    this.isPageForm.next(false);
    this.dialogRef.updateSize('90vw', '90vh');
    // .. Lấy số phiếu mới
    this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
      if (res.status == 1) {
        this.DNNKItem = this.data.data;
        this.DNNKItem.Sophieu = res.data;
        this.DNNKItem.isCreateQT = false;
        if (this.DNNKForm != null)
          form["SoPhieu"].setValue(this.DNNKItem.Sophieu);
        // .. Thêm data vào form
        this.DNNKItem.listChiTietNhapKho.forEach(x => {
          x.IdCtdn = 0;
          x.isDone = false;
          x.DaLapPhieuNhapKho = false;
          x.Nguoikiemtra = 0;
          x.Ngaykiemtra = '';
          x.Quyetdinhlohang = -1;
        })
        form["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
        //form["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
        form["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
        form["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
        this.checkState();
        this.checkPB();
        // .. Thêm dữ liệu list
        if (this.DNNKItem.listChiTietNhapKho.length > 0) {
          this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
          this.tmpChiTietDNNK = [];
          var ids = this.DNNKItem.listChiTietNhapKho.map(x => x.MaHH).join(CONSTANT_COMMA);
          this.dungChungService.top_list_of_merchandise(ids, 0).subscribe((res) => {
            if (res && res.status === 1) {
              for (let i = 0; i < this.listChiTietDNNK.length; i++) {
                var iMer = res.data.findIndex(x => x.Id_HH == this.listChiTietDNNK[i].IdHh);
                if (this.listChiTietDNNK[i].SoLuongThucNhap == null) {
                  this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
                }
                this.listChiTietDNNK[i].listDVTInfo = [];
                this.listChiTietDNNK[i].listDVTInfo.push(
                  {
                    IdDVT: this.listId_HH[iMer].Dvt3,
                    TenDVT: this.listId_HH[iMer].TenDVT3,
                    QuyDoiDVT: this.listId_HH[iMer].QuiDoiDVT3
                  },
                  {
                    IdDVT: this.listId_HH[iMer].Dvt2,
                    TenDVT: this.listId_HH[iMer].TenDVT2,
                    QuyDoiDVT: this.listId_HH[iMer].QuiDoiDVT2
                  },
                  {
                    IdDVT: this.listId_HH[iMer].DVT,
                    TenDVT: this.listId_HH[iMer].TenDVT,
                    QuyDoiDVT: 1
                  }
                )
                this.listChiTietDNNK[i].listDVTInfo = this.listChiTietDNNK[i].listDVTInfo.filter(x => x.IdDVT) // remove null
                this.listChiTietDNNK[i].Dvt = this.listChiTietDNNK[i].listDVTInfo.reverse()[0].IdDVT;
                var redeem = this.listChiTietDNNK[i].listDVTInfo.find(x => x.IdDVT == this.listChiTietDNNK[i].DvtQuyDoi)
                var listIdHH = this.listChiTietDNNK[i].listDVTInfo.map(x => x.IdDVT);
                this.listChiTietDNNK[i].listDVTInfo = this.listChiTietDNNK[i].listDVTInfo.filter((e, i) => listIdHH.indexOf(e.IdDVT) === i);
                this.listChiTietDNNK[i].Soluongchungtu = '' + (Number(this.listChiTietDNNK[i].KhoiLuongQuyDoi) * Number(redeem.QuyDoiDVT))
                let tmpElement = new DeNghiNhapKhoChiTiet();
                tmpElement.copy(this.listChiTietDNNK[i])
                this.tmpChiTietDNNK.push(tmpElement);
              }
              this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
            }
            this.changeDetectView();
          });
        }
      }
    });

  }
  handleDoiTraHangFormDialog() {

    const CONSTANT_COMMA = ",";
    var form = this.DNNKForm.controls;
    // .. Custom UI
    this.isPageForm.next(false);
    this.dialogRef.updateSize('90vw', '65vh');
    // .. Lấy số phiếu mới
    this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
      if (res.status == 1) {
        //this.DNNKItem = this.data.data;
        this.DNNKItem.Sophieu = res.data;
        this.DNNKItem.isCreateQT = false;
        if (this.listLoaiPhieu && this.listLoaiPhieu.length > 0) {
          this.DNNKItem.LoaiPhieu = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value).Id;
        } else {
          setTimeout(() => {
            this.DNNKItem.LoaiPhieu = this.listLoaiPhieu.find(x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value).Id;
          }, 500);
        }
        this.DNNKItem.IdKh = this.data.data[0].IdKh;
        this.afterSelectKH(this.DNNKItem.IdKh.toString());
        if (this.DNNKForm != null)
          form["SoPhieu"].setValue(this.DNNKItem.Sophieu);
        // .. Thêm data vào form
        this.DNNKItem.listChiTietNhapKho.forEach(x => {
          x.IdCtdn = 0;
          x.isDone = false;
          x.DaLapPhieuNhapKho = false;
          x.Nguoikiemtra = 0;
          x.Ngaykiemtra = '';
          x.Quyetdinhlohang = -1;
        })
        form["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
        //form["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
        form["BPNhap"].setValue(this.DNNKItem.BoPhanNhap.toString());
        form["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
        this.checkState();
        this.checkPB();
        this.changeLyDo()
        // .. Thêm dữ liệu list
        if (this.data.data.length > 0) {
          //this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
          this.tmpChiTietDNNK = [];
          var ids = this.data.data.length > 1 ? this.data.data.map(x => x.HangHoaId).join(CONSTANT_COMMA) : [this.data.data[0].HangHoaId + ","];
          this.dungChungService.top_list_of_merchandise_lite(ids, 0).subscribe((res) => {
            if (res && res.status === 1) {
              this.data.data.forEach(element => {
                var iMer = res.data.findIndex(x => x.Id_HH == element.HangHoaId);
                if (element.SoLuongThucNhap == null) {
                  element.SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
                }
                element.IdHh = element.HangHoaId;
                element.listDVTInfo = [];
                element.listDVTInfo.push(
                  {
                    IdDVT: res.data[iMer].Dvt3,
                    TenDVT: res.data[iMer].TenDVT3,
                    QuyDoiDVT: res.data[iMer].QuiDoiDVT3
                  },
                  {
                    IdDVT: res.data[iMer].Dvt2,
                    TenDVT: res.data[iMer].TenDVT2,
                    QuyDoiDVT: res.data[iMer].QuiDoiDVT2
                  },
                  {
                    IdDVT: res.data[iMer].DVT,
                    TenDVT: res.data[iMer].TenDVT,
                    QuyDoiDVT: 1
                  }
                )
                element.listDVTInfo = element.listDVTInfo.filter(x => x.IdDVT) // remove null
                element.DvtQuyDoi = element.listDVTInfo.reverse()[0].IdDVT;
                element.TenDvtQuyDoi = element.listDVTInfo.reverse()[0].TenDVT;
                var redeem = element.listDVTInfo.find(x => x.IdDVT == element.Dvt)
                var listIdHH = element.listDVTInfo.map(x => x.IdDVT);
                element.listDVTInfo = element.listDVTInfo.filter((e, i) => listIdHH.indexOf(e.IdDVT) === i);
                element.KhoiLuongQuyDoi = '' + element.SoLuongDoi
                element.Soluongchungtu = '' + (Number(element.KhoiLuongQuyDoi) * Number(redeem.QuyDoiDVT))
                element.ExpiryDate = element.HanSuDung
                element.Solo = element.SoLo
                element.Ghichulohang = element.HuongXuLy
                element.IdCtDth = element.Id
                let tmpElement = new DeNghiNhapKhoChiTiet();
                tmpElement.copy(element)
                this.tmpChiTietDNNK.push(tmpElement);
              });
              // for(let i = 0; i < this.data.data.length; i++){
              // 	var iMer = res.data.findIndex(x => x.Id_HH == this.listChiTietDNNK[i].IdHh);
              // 	if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
              // 		this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
              // 	}
              // 	this.listChiTietDNNK[i].listDVTInfo = [];
              // 	this.listChiTietDNNK[i].listDVTInfo.push(
              // 		{
              // 			IdDVT: this.listId_HH[iMer].Dvt3,
              // 			TenDVT: this.listId_HH[iMer].TenDVT3,
              // 			QuyDoiDVT: this.listId_HH[iMer].QuiDoiDVT3
              // 		},
              // 		{
              // 			IdDVT: this.listId_HH[iMer].Dvt2,
              // 			TenDVT: this.listId_HH[iMer].TenDVT2,
              // 			QuyDoiDVT: this.listId_HH[iMer].QuiDoiDVT2
              // 		},
              // 		{
              // 			IdDVT: this.listId_HH[iMer].DVT,
              // 			TenDVT: this.listId_HH[iMer].TenDVT,
              // 			QuyDoiDVT: 1
              // 		}
              // 	)
              // 	this.listChiTietDNNK[i].listDVTInfo = this.listChiTietDNNK[i].listDVTInfo.filter(x => x.IdDVT) // remove null
              // 	this.listChiTietDNNK[i].Dvt 		= this.listChiTietDNNK[i].listDVTInfo.reverse()[0].IdDVT;
              // 	var redeem 		= this.listChiTietDNNK[i].listDVTInfo.find(x => x.IdDVT == this.listChiTietDNNK[i].DvtQuyDoi)
              // 	var listIdHH 	= this.listChiTietDNNK[i].listDVTInfo.map(x => x.IdDVT);
              // 	this.listChiTietDNNK[i].listDVTInfo = this.listChiTietDNNK[i].listDVTInfo.filter((e, i) => listIdHH.indexOf(e.IdDVT) === i);
              // 	this.listChiTietDNNK[i].Soluongchungtu = '' + (Number(this.listChiTietDNNK[i].KhoiLuongQuyDoi) * Number(redeem.QuyDoiDVT))
              // 	let tmpElement 	= new DeNghiNhapKhoChiTiet();
              // 	tmpElement.copy(this.listChiTietDNNK[i])
              // 	this.tmpChiTietDNNK.push(tmpElement);
              // }
              this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
            }
            this.changeDetectView();
          });
        }
      }
    });

  }
  // .............................................................
  // .. Điều hướng quay lại
  routerBack() {
    if (this.isPageForm.value)
      this.router.navigateByUrl('de-nghi-nhap-kho', { relativeTo: this.activatedRoute });
    else
      this.dialogRef.close();
  }
  // .............................................................
  filterReceiveDivision() {
    const search = this.receiveDivisonFtrCtrl;
    if (!this.orgStructureTree) return;
    if (!search) {
      this.ftrReceiveDivison.next([...this.orgStructureTree]);
      return;
    }
    const lowerCaseSearch = search.toLowerCase().trim();
    this.ftrReceiveDivison.next(
      this.orgStructureTree.filter(ts =>
        ts.TenPB.toLowerCase().includes(lowerCaseSearch)
      )
    );
    this.changeDetectView();
  }
  filterRequestDepartment() {
    const search = this.requestDepartmentFtrCtrl;
    if (!this.orgStructureTree) return;
    if (!search) {
      this.ftrRequestDepartment.next([...this.orgStructureTree]);
      return;
    }
    const lowerCaseSearch = search.toLowerCase().trim();
    this.ftrRequestDepartment.next(
      this.orgStructureTree.filter(ts =>
        ts.TenPB.toLowerCase().includes(lowerCaseSearch)
      )
    );
    this.changeDetectView();
  }
  filterImporttDepartment() {
    const search = this.importDepartmentFtrCtrl;
    if (!this.orgStructureTree) return;
    if (!search) {
      this.ftrImportDepartment.next([...this.orgStructureTree]);
      return;
    }
    const lowerCaseSearch = search.toLowerCase().trim();
    this.ftrImportDepartment.next(
      this.orgStructureTree.filter(ts =>
        ts.TenPB.toLowerCase().includes(lowerCaseSearch)
      )
    );
    this.changeDetectView();
  }
  // Hàm này được sử dụng để tải các tùy chọn phòng ban từ một giá trị nhất định
  loadDivisionOptions(value: string, setValueControl: boolean = true) {
    // Lấy các controls của form
    const form = this.DNNKForm.controls;

    // Chuyển đổi giá trị lựa chọn thành số nguyên
    const selectedOptionDepartment = Number(value);

    // Khởi tạo mảng chứa các tùy chọn cho dropdown
    let dropdownOptions: any[] = [];

    // Kiểm tra xem có dữ liệu trong dataTree và có phải là mảng không
    if (this.datatree && Array.isArray(this.datatree.value) && this.datatree.value.length > 0) {
      // Tải dữ liệu cho dropdown từ giá trị id trong dataTree
      dropdownOptions = this.loadOptionTreeDataFromIdParam(this.datatree.value[0], [], selectedOptionDepartment);

      // Kiểm tra xem dropdown có dữ liệu con hay không
      const hasSubData = dropdownOptions.length > 1;

      // Lọc các tùy chọn con nếu có
      const subData = dropdownOptions.filter(option => option.Id_PB != selectedOptionDepartment);

      // Cập nhật tùy chọn của dropdown dựa trên có dữ liệu con hay không
      this.optionsDivision = hasSubData ? subData : dropdownOptions;
      this.ftrReceiveDivison.next([...this.optionsDivision]);

      if (setValueControl) {
        // Cập nhật tùy chọn vào dropdown

        // Nếu không có dữ liệu con, đặt giá trị cho control "NewBPSD"
        form["BPNhap"].setValue(!hasSubData ? dropdownOptions[0].Id_PB + '' : '');

        // Nếu có dữ liệu con, cập nhật validator cho control "BPSD"
        if (hasSubData) {
          form["BPNhap"].setValidators([Validators.required]);
          form["BPNhap"].updateValueAndValidity();
        }
      }
    }

    // Gọi hàm để cập nhật giao diện
    this.changeDetectView();
  }
  // Load tree from id node
  loadOptionTreeDataFromIdParam(data, ouput: any[], nodeID: number = 0) {
    if (!data) return;
    if (data) {
      var renewNodeId = false;
      if (data.Id_PB === nodeID) {
        ouput.push({
          Id_PB: data["Id_PB"],
          TenPB: data["TenPB"]
        });
        renewNodeId = true;
      }
      if (data.Childrens && data.Childrens.length > 0) {
        data.Childrens.forEach(child => {
          this.loadOptionTreeDataFromIdParam(child, ouput, renewNodeId ? child.Id_PB : nodeID);
        })
      }
    }
    return ouput;
  }
  filterUsingDivision() {
    const search = this.receiveDivisonFtrCtrl;
    if (!this.optionsDivision) return;
    if (!search) {
      this.ftrReceiveDivison.next([...this.optionsDivision]);
      return;
    }
    const lowerCaseSearch = search.toLowerCase().trim();
    this.ftrReceiveDivison.next(
      this.optionsDivision.filter(ts =>
        ts.TenPB.toLowerCase().includes(lowerCaseSearch)
      )
    );
    this.changeDetectView();
  }

  handleFormFromPurchaseOrder(data: any) {
    console.log(data)
    this.isPageForm.next(false);
    //this.dialogRef.updateSize('90vw', '90vh');
    const form = this.DNNKForm.controls;
    this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
      if (res.status == 1) {
        this.DNNKItem.Sophieu = res.data;
        this.DNNKItem.isCreateQT = false;
        this.DNNKItem.Nguoitao = data.Nguoitao;
        if (form != null) {
          form["SoPhieu"].setValue(this.DNNKItem.Sophieu);
          if (data) {
            form["TrangThai"].setValue(data.TenTinhTrang);
            form["LoaiPhieu"].setValue(data.LoaiPhieu.toString());
            form["LyDoCode"].setValue(data.LyDoCode);
            form["PBDeNghi"].setValue(data.BoPhanDeNghi.toString());
            form["PBNhap"].setValue(data.PhongBanNhap.toString());
            form["ChungTuKemTheo"].setValue(false);
            form["ManufacturingDate"].setValue(null);
            form["TenNguoiLap"].setValue(data.TenNguoitao);
            this.DNNKForm.disable();
            this.HHForm.disable();

            if (data.listChiTietNhapKho && Array.isArray(data.listChiTietNhapKho)) {
              const listChiTietDNNK = data.listChiTietNhapKho;
              const productListId = Array.from(new Set(listChiTietDNNK.map(r => r.IdHh)));
              const productListStr = productListId.length > 0 ? productListId.join(",") + "," : "";

              this.dungChungService.top_list_of_merchandise_lite(productListStr, productListId.length).subscribe(res => {
                if (res && res.status === 1) {
                  this.listId_HH = res.data || [];
                  this.tmpChiTietDNNK = [];
                  listChiTietDNNK.forEach(element => {
                    const productForm = this.HHForm.controls;

                    this.selectId_HH = element.IdHh != null ? element.IdHh.toString() : "";
                    productForm["DVT"].setValue(element.Dvt != null ? element.Dvt.toString() : "");
                    productForm["SoLuong"].setValue(element.Soluongchungtu != null ? this.f_number(element.Soluongchungtu) : 0);
                    productForm["Solo"].setValue(element.Solo != null ? element.Solo : "");
                    productForm["NCC"].setValue(element.IdNcc != null ? element.IdNcc.toString() : "");
                    productForm["SoPONCC"].setValue(element.SoPONCC);
                    productForm["PalletText"].setValue(null);

                    this.addDetail();
                    if (this.tmpChiTietDNNK.length > 0) {
                      const lastIdx = this.tmpChiTietDNNK.length - 1;
                      this.tmpChiTietDNNK[lastIdx].NguonPhatSinh = element.NguonPhatSinh;
                      this.tmpChiTietDNNK[lastIdx].IdNguon = element.IdNguon;
                    }
                  });
                }
              });
            }
          }
        }
        this.changeDetectView();
      }
    });
  }
}
